import React, {useEffect, useState} from 'react';
import {Card, Col, Row, Button, Spinner, Collapse} from "reactstrap";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import useApiCallService from "../../Common/Helpers/ApiCall";
import RequestReimbursementFixed from "../Models/Request/RequestReimbursementFixed"
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import RequestReimbursementMileage from "../Models/Request/RequestReimbursementMileage";
import RequestReimbursementExpense from "../Models/Request/RequestReimbursementExpense";
import $ from 'jquery';
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import ResponseReimbursement from "../Models/Response/ResponseReimbursement";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import {Link, useNavigate} from "react-router-dom";
import {REPORT_PROCEEDING_PATHS, USER_PATHS, MAX_FILE_SIZE_BYTES} from "../../config";
import {ReimbursementFixed} from "../Components/ReimbursementFixed";
import {ReimbursementMileage} from "../Components/ReimbursementMileage";
import {CustomModal} from "../../Common/Components/Modal/CustomModal";
import {ReimbursementExpense} from "../Components/ReimbursementExpense";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import RequestPassenger from "../Models/Request/RequestPassenger";
import {StringToLowerCaseFirst} from "../../Common/Helpers/StringToLowerCaseFirst";
import {GetDocumentGroupKey, HasFilledAdditionalInfo, GetSharedGroupValues, IsInSameDocumentGroup, ShareInfoByDocumentGroup, UniqueByDocumentGroup} from "../Helpers/RequiredDocumentationGroup";
import {useTranslation} from "react-i18next";
import {CheckDecimal} from "../../Common/Helpers/CheckDecimal";
import {CustomUnsavedModal} from "../../Common/Components/Modal/CustomUnsavedModal";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {CustomReimbursementView} from "../Components/CustomReimbursementView";
import {CustomReimbursementFixedView} from "../Components/CustomReimbursementFixedView";
import {CustomReimbursementMileageView} from "../Components/CustomReimbursementMileageView";
import {CustomReimbursementExpenseView} from "../Components/CustomReimbursementExpenseView";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {useSelector} from "react-redux";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import _, { set } from "lodash";
import RequestReimbursementV2 from "../Models/Request/RequestReimbursementV2";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import { ReimbursementParticipants } from '../Components/ReimbursementParticipants';
import { CustomReimbursementParticipantsView } from '../Components/CustomReimbursementParticipantsView';
import RequestAdditionalInfo from '../Models/Request/RequestAdditionalInfo';
import RequestFile from '../Models/Request/RequestFile';
import RequestComment from '../Models/Request/RequestComment';
import { CustomReimbursementAttachmentView } from '../Components/CustomReimbursementAttachmentView';
import { CustomReimbursementCommentView } from '../Components/CustomReimbursementCommentView';
import { InsufficientFundsModal } from '../../Common/Components/InsufficientFundsModal';
import { useHeader } from '../../Auth/Components/Nav/HeaderContext';
import { CheckMobile } from '../../AppSystem/Helpers/CheckMobile';
import { CustomReimbursementAttachmentCommentView } from '../Components/CustomReimbursementAttachmentCommentView';
import { useLocation } from 'react-router-dom';

export function ReportProceedingV2() {

    const [tempCommentList, setTempCommentList] = useState([{ id: 'default-comment' }]);
    const [tempFileList, setTempFileList] = useState([]);
    const [tempAdditionalInfoList, setTempAdditionalInfoList] = useState([]);
    const [openReimbursementAccordion, setOpenReimbursementAccordion] = useState(false);
    
    const { t } = useTranslation()
    const {ApiCall} = useApiCallService();
    const navigate = useNavigate();
    const { userData, orgData } = useSelector(state => state.auth);
    const location = useLocation();
    const navState = location.state || {};
    const backButtonUrl = navState?.returnTo || REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_LIST;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const isMobile = CheckMobile(998);

    const { setPageTitle, setPageTitleKey, setOnBack, setIsCross } = useHeader();

    useEffect(() => {
        setPageTitle(t('reimbursement.reportProcessing'));
        setPageTitleKey('reimbursement.reportProcessing');
        setIsCross(true);
        setOnBack(() => {
            //navigate(REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_LIST);
            setCheckUnsaved(true);
        });

        document.documentElement.classList.add('no-pull-to-refresh');

        return () => {
            setPageTitle('');
            setPageTitleKey('');
            setIsCross(false);
            setOnBack(null);
            document.documentElement.classList.remove('no-pull-to-refresh');
        };
    }, [t]);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.dispatchEvent(new CustomEvent('mobileNavForceHide', { detail: { hidden: true } }));
        }, 0);
        
        return () => {
            clearTimeout(timer);
            window.dispatchEvent(new CustomEvent('mobileNavForceHide', { detail: { hidden: false } }));
        };
    }, []);

    // GET ID IF EXISTS FOR DRAFT
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";

    const urlDate       = navState.date        ?? "";
    const urlToDate     = navState.toDate      ?? null;
    const urlPurpose    = navState.purpose     ?? "";
    const urlCostBearer = navState.costBearerId ?? "";

    // PERMISSIONS
    let permissionCreate = false;
    if (CheckUserPermission("user") || CheckUserPermission("user.reimbursement") || CheckUserPermission("user.reimbursement.create")) {
        permissionCreate = true;
    }

    // CHECK UNSAVED
    const [checkUnsaved, setCheckUnsaved] = useState(false);

    useEffect(() => {
        if (urlDate || urlToDate || urlPurpose || urlCostBearer) {
            setCheckUnsaved(true);
        }
    }, []);

    // REQUESTS
    //const [requestReimbursement, setRequestReimbursement] = useState(new RequestReimbursementV2());
    const [requestReimbursementFixed, setRequestReimbursementFixed] = useState(new RequestReimbursementFixed());
    const [requestReimbursementFixedList, setRequestReimbursementFixedList] = useState([]);
    const [requestReimbursementMileage, setRequestReimbursementMileage] = useState(new RequestReimbursementMileage());
    const [requestReimbursementExpense, setRequestReimbursementExpense] = useState(new RequestReimbursementExpense());
    const [requestAdditionalInfo, setRequestAdditionalInfo] = useState(new RequestAdditionalInfo());
    const [requestReimbursementParticipants, setRequestReimbursementParticipants] = useState([]);
    const [requestReimbursementExpenseList, setRequestReimbursementExpenseList] = useState([]);
    const [requestAdditionalInfoList, setRequestAdditionalInfoList] = useState([]);
    const [requestCommentList, setRequestCommentList] = useState([]);
    const [requestFileList, setRequestFileList] = useState([]);
    const [otherComments, setOtherComments] = useState([{ id: 'default-comment' }]);
    const [otherFiles, setOtherFiles] = useState([]);
     const [uploadContext, setUploadContext] = useState(null);
     const [uploadTarget, setUploadTarget] = useState({ id: null, fieldName: null, expenseIndex: null });

    // RESPONSES
    const [infoResponse, setInfoResponse] = useState(null);
    const [draftResponse, setDraftResponse] = useState(null);
    const [responseReimbursement, setResponseReimbursement] = useState(new ResponseReimbursement());
    const [responseDelete, setResponseDelete] = useState(null);
    const [responseConfirmFunds, setResponseConfirmFunds] = useState(null);

    // VALIDATION SCHEMAS
    const completeSchema = RequestReimbursementV2.getAttributes(null, "send");
    const completeSchemaSave = RequestReimbursementV2.getAttributes(null, "save");
    const completeSchemaFixed = RequestReimbursementFixed.getAttributes(null, true);
    const completeSchemaMileage = RequestReimbursementMileage.getAttributes(null, true);
    const completeSchemaPassenger = RequestPassenger.getAttributes(null, true);
    const completeSchemaExpense = RequestReimbursementExpense.getAttributes( null, true);

    // REIMBURSEMENT FIXED
    const [isFixed, setIsFixed] = useState(false);
    const [wasAddedFixed, setWasAddedFixed] = useState(false);
    const [deletedFixed, setDeletedFixed] = useState(false);

    // REIMBURSEMENT EXPENSE
    const [fileType, setFileType] = useState("");
    const [fileResponse, setFileResponse] = useState(null);
    const [additionalFileResponse, setAdditionalFileResponse] = useState(null);
    const [addedExpense, setAddedExpense] = useState(false);
    const [expenseIndex, setExpenseIndex] = useState(null);
    const [requestName , setRequestName] = useState("");
    const [requestName2 , setRequestName2] = useState("");
    const [extraField , setExtraField] = useState(null);
    const [extraField2 , setExtraField2] = useState(null);
     const [extraFields , setExtraFields] = useState([]);
    const [isDeletedFile, setIsDeletedFile] = useState(false);
    const [isDeletedExtraFile, setIsDeletedExtraFile] = useState(false);
    const [localDisplayExpense, setLocalDisplayExpense] = useState(false);

    const [localDisplayParticipants, setLocalDisplayParticipants] = useState(false);
    const [accordionStatusParticipants, setAccordionStatusParticipants] = useState(false);
    const [editModeParticipants, setEditModeParticipants] = useState(false);
    const [addedAttachments, setAddedAttachments] = useState(false);
    const [addedAttachmentsExtra, setAddedAttachmentsExtra] = useState(false);

    // SELECTS
    const [orgs, setOrgs] = useState({});
    const [accountings, setAccountings] = useState({});
    const [costBearers, setCostBearers] = useState({});

    // GROSS AMOUNT
    const [grossAmount, setGrossAmount] = useState(0);

    const [requestReimbursement, setRequestReimbursement] = useState(() => {
        const r = new RequestReimbursementV2();
        if (urlDate)        r.date         = urlDate;
        r.toDate = urlToDate; 
        if (urlPurpose)     r.purpose      = urlPurpose;
        if (urlCostBearer)  r.costBearerId = urlCostBearer;
        return r;
    });

    // ORG ID
    const urlOrgId = navState.orgId ?? new URLSearchParams(window.location.search).get('orgId') ?? "";
    const [selectedOrgId, setSelectedOrgId] = useState(urlOrgId || orgData.orgId || "");
    const [selectedOrgName, setSelectedOrgName] = useState("");
    const [selectedCostBearerId, setSelectedCostBearerId] = useState(urlCostBearer || "");
    const [selectedCostBearerName, setSelectedCostBearerName] = useState("");
    const [selectedOrgType, setSelectedOrgType] = useState("");

    // EDIT MODE
    const [editModeFixed, setEditModeFixed] = useState(false);
    const [editModeMileage, setEditModeMileage] = useState(false);
    const [editModeExpense, setEditModeExpense] = useState(false);

    // DISPLAY FORMS
    const [displayFixed, setDisplayFixed] = useState(true);
    const [displayMileage, setDisplayMileage] = useState(true);
    const [displayExpense, setDisplayExpense] = useState(true);

    // MODALS
    const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
    const [reimbursementToDelete, setReimbursementToDelete] = useState("");
    const [displaySendModal, setDisplaySendModal] = useState(false);
    const [displayConfirmFundsModal, setDisplayConfirmFundsModal] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [displaySpinner, setDisplaySpinner] = useState(false);
    const [displayDeleteReimbursementModal, setDisplayDeleteReimbursementModal] = useState(false);
    const [displaySuccessModal, setDisplaySuccessModal] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    //const [mobileStep, setMobileStep] = useState(1);

    /********************************************* GET INFO ******************************************/
    // GET NECESSARY INFO
    useEffect(() => {
        const HandleInfoResponse = (response) => {
            setRequestReimbursement((prevFormData) => ({
                ...prevFormData,
                toDate: urlToDate ?? null,
            }));
            let orgType = "";
            // ORGS
            if (response.orgsByUser && Array.isArray(response.orgsByUser) && response.orgsByUser.length > 0) {
                const orgArray = [];
                response.orgsByUser.map(item => {
                    if (item.id === selectedOrgId) {
                        orgType = item.type;
                        setSelectedOrgType(item.type);
                        setSelectedOrgName(item.name);
                    }
                    orgArray.push({
                        id: item.id,
                        name: item.type != null ? `${item.name} (${item.type})` : item.name,
                    });
                });
                setOrgs({
                    org: orgArray
                });
            }

            // ACCOUNTINGS
            if (response.accountings && Array.isArray(response.accountings) && response.accountings.length > 0) {
                const accountingArray = [];
                response.accountings.map(item => {
                    accountingArray.push({
                        id: item.id,
                        name: item.showLabel,
                        message: item.message
                    });
                });
                setAccountings({
                    accounting: accountingArray
                });
            }

            // COST BEARERS
            if (orgType !== "" && response.costBearers && Array.isArray(response.costBearers) && response.costBearers.length > 0 && response.costBearersByOrgType && Array.isArray(response.costBearersByOrgType) && response.costBearersByOrgType.length > 0) {
                response.costBearers.map(item => {
                    if (item.id === selectedCostBearerId) {
                        setSelectedCostBearerName(item.showLabel ? item.showLabel : item.name);
                    }
                });
                const costBearersByOrgType = response.costBearersByOrgType.find(item => item.type === orgType);
                if (costBearersByOrgType) {
                    const costBearerJsonArray = response.costBearers.filter(cb => costBearersByOrgType.costBearerNames.includes(cb.name)).map(cb => ({ id: cb.id, name: cb.showLabel || cb.name }));
                    setCostBearers({
                        costBearer: costBearerJsonArray
                    });
                }
            }

            setInfoResponse(response);
        };

        const GetInfo = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: `/reimbursement/v2/info`
                };
                await ApiCall(apiCallOptions, HandleInfoResponse);
            } catch (error) {
                //console.log({error});
            }
        };
        GetInfo();
    }, []);

    // GET REIMBURSEMENT DRAFT
    useEffect(() => {
        // Wait until infoResponse is loaded
        if (id !== "" && infoResponse !== null) {
            const HandleDraftResponse = (response) => {
                if (response.reimbursement) {
                    setCheckUnsaved(true);
                    //console.log({response});
                    setTimeout(() => {
                        setRequestReimbursement(new RequestReimbursementV2(response.reimbursement));
                    }, 100);
                    if ((response.reimbursement.toDate && response.reimbursement.toDate === "") || !response.reimbursement.toDate) {
                        setTimeout(() => {
                            setRequestReimbursement((prevFormData) => ({
                                ...prevFormData,
                                toDate: null,
                            }));
                        }, 150);
                    }
                    if (response.reimbursement.fixeds && Array.isArray(response.reimbursement.fixeds) && response.reimbursement.fixeds.length > 0) {
                        setDisplayFixed(false);
                        setEditModeFixed(false);
                        if (response.reimbursement.fixeds.length > 1) {
                            setRequestReimbursementFixedList(response.reimbursement.fixeds.map(item => {
                                return new RequestReimbursementFixed(item);
                            }));
                        } else {
                            if (response.reimbursement.fixeds[0].type === "Fixed") {
                                setIsFixed(true);
                                setWasAddedFixed(true);
                                setRequestReimbursementFixed(new RequestReimbursementFixed(response.reimbursement.fixeds[0]));
                            } else {
                                setRequestReimbursementFixedList(response.reimbursement.fixeds.map(item => {
                                    return new RequestReimbursementFixed(item);
                                }));
                            }
                        }
                        setTimeout(() => {
                            $("#date, #toDate, #checkInput").prop("disabled", true);
                        }, 200);
                    }
                    if (response.reimbursement.mileage) {
                        setDisplayMileage(false);
                        setEditModeMileage(false);
                        setRequestReimbursementMileage(new RequestReimbursementMileage(response.reimbursement.mileage));
                    }
                    if (response.reimbursement.date) {
                        setRequestReimbursementExpense((prevFormData) => ({
                            ...prevFormData,
                            dateReceive: response.reimbursement.date,
                        }));
                    }
                    if (response.reimbursement.expenses && response.reimbursement.expenses.length > 0) {
                        setAddedExpense(true);
                        setEditModeExpense(false);
                        setRequestReimbursementExpenseList(response.reimbursement.expenses.map(item => {
                            return new RequestReimbursementExpense(item);
                        }));
                        
                            // Create an item for EACH expense (without filtering duplicates)
                            const additionalInfoList = response.reimbursement.expenses.map(expense => {
                                // Search accounting data for this expense
                                const accountingData = infoResponse.accountings?.find(
                                    acc => acc.id === expense.accountingId
                                );
                                
                                // Find extra fields for this accounting
                                const foundExtra = infoResponse.accountingsExtraFields?.find(
                                    extra => extra.accountingId === expense.accountingId
                                );
                                
                                // Initialize additionalInfo with necessary fields
                                let additionalInfoData = {};
                                if (foundExtra && foundExtra.extraFields && foundExtra.extraFields.length > 0) {
                                    foundExtra.extraFields.forEach(field => {
                                        const fieldName = StringToLowerCaseFirst(field.requestName);
                                        additionalInfoData[fieldName] = expense.additionalInfo?.[fieldName] ?? "";
                                    });
                                } else if (expense.additionalInfo && Object.keys(expense.additionalInfo).length > 0) {
                                    additionalInfoData = { ...expense.additionalInfo };
                                }

                                let selectedRadioOption = null;
                                if (expense.additionalInfo) {
                                    if (expense.additionalInfo.program !== undefined && 
                                        expense.additionalInfo.program !== null && 
                                        expense.additionalInfo.program !== "") {
                                        selectedRadioOption = "option1";
                                    }
                                    else if (expense.additionalInfo.participantsFileId !== undefined && 
                                            expense.additionalInfo.participantsFileId !== null && 
                                            expense.additionalInfo.participantsFileId !== "") {
                                        selectedRadioOption = "option2";
                                    }
                                }
                                
                                return {
                                    accountingId: expense.accountingId,
                                    accountingName: expense.accountingName,
                                    additionalInfo: additionalInfoData,
                                    additionalFileExtension: expense.additionalFileExtension || "",
                                    additionalFileName: expense.additionalFileName || "",
                                    requiredDocumentation: accountingData?.requiredDocumentation || 
                                                        accountingData?.requiredDocuments || [],
                                    selectedRadioOption: selectedRadioOption
                                };
                            });
                            
                        // Expenses with the same required documentation share the same list/attachment
                        const sharedAdditionalInfoList = ShareInfoByDocumentGroup(additionalInfoList);
                        setAddedAttachments(true);
                        setRequestAdditionalInfoList(sharedAdditionalInfoList);
                        setTempAdditionalInfoList(sharedAdditionalInfoList);
                    }
                    if (response.reimbursement.orgId && response.reimbursement.orgId !== "") {
                        setSelectedOrgId(response.reimbursement.orgId);
                    }
                    if (response.reimbursement.orgName && response.reimbursement.orgName !== "") {
                        setSelectedOrgName(response.reimbursement.orgName);
                        setSelectedOrgType(response.reimbursement.orgType);
                    }
                    if (response.reimbursement.costBearerId && response.reimbursement.costBearerId !== "") {
                        setSelectedCostBearerId(response.reimbursement.costBearerId);
                    }
                    if (response.reimbursement.costBearerName && response.reimbursement.costBearerName !== "") {
                        setSelectedCostBearerName(response.reimbursement.costBearerName);
                    }
                    if(response.reimbursement.attachments) {
                        if(response.reimbursement.attachments.fileList && response.reimbursement.attachments.fileList.length > 0) {
                             const formattedFileList = response.reimbursement.attachments.fileList.map(file => ({
                                ...file,
                                id: file.fileId
                            }));
                            setRequestFileList(formattedFileList);
                            setOtherFiles(formattedFileList);
                            //setRequestFileList(response.reimbursement.attachments.fileList);
                            //setOtherFiles(response.reimbursement.attachments.fileList);
                            setAddedAttachments(true);
                            setAddedAttachmentsExtra(true);
                            // NUEVO AGREGADO INICIO
                            setRequestFileList(formattedFileList);
                            setTempFileList(formattedFileList);
                            // NUEVO AGREGADO FIN
                        }
                        if(response.reimbursement.attachments.commentList && response.reimbursement.attachments.commentList.length > 0) {
                            setRequestCommentList(response.reimbursement.attachments.commentList);
                            setOtherComments(response.reimbursement.attachments.commentList);
                            setAddedAttachments(true);
                            setAddedAttachmentsExtra(true);
                            // NUEVO AGREGADO INICIO
                            setRequestCommentList(response.reimbursement.attachments.commentList);
                            setTempCommentList(response.reimbursement.attachments.commentList);
                            // NUEVO AGREGADO FIN
                        }
                    }
                }
                setDraftResponse(response);
            };
            const GetReimbursement = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/reimbursement/v2?id=${id}`
                    };
                    await ApiCall(apiCallOptions, HandleDraftResponse);
                } catch (error) {
                    //console.log({error});
                }
            };
            GetReimbursement();
        }
    }, [infoResponse]);
    /********************************************* GET INFO ******************************************/

    /********************************************* COMMON ********************************************/
    // HANDLE CHANGE COMMON
    const HandleChangeCommon = (e, name, isDraft = null) => {
        if (isDraft === null) {
            setCheckUnsaved(true);
        }
        let value = e?.target?.value && e?.target?.value !== "" ? e.target.value : "";
        let salaryDateValue = requestReimbursement.date;
        let dateValue = requestReimbursement.date;
        let toDateValue = requestReimbursement.toDate;
        let dateReceiveValue = requestReimbursementExpense.dateReceive && requestReimbursementExpense.dateReceive !== "" ? ChangeDateFormat("date", requestReimbursementExpense.dateReceive) : "";
        switch (name) {
            case "orgId":
                setSelectedOrgId(e.target.value);
                break;
            case "costBearerId":
                setSelectedCostBearerId(e.target.value);
                break;
            case "date":
                dateValue = e && e !== "" ? ChangeDateFormat('date', e) : "";
                break;
            case "toDate":
                toDateValue = e && e !== "" ? ChangeDateFormat('date', e) : "";
                break;
        }
        if (name === "date" /*|| name === "toDate"*/) {
            salaryDateValue = dateValue;
            if (dateReceiveValue === "") {
                dateReceiveValue = dateValue;
            }
        }
        if (name === "check") {
            if (toDateValue === null) {
                toDateValue = "";
            } else {
                toDateValue = null;
            }
        }
        setRequestReimbursement((prevFormData) => ({
            ...prevFormData,
            [name]: value,
            date: dateValue,
            toDate: toDateValue,
        }));
        setRequestReimbursementFixed((prevFormData) => ({
            ...prevFormData,
            [name]: value,
            date: dateValue,
            toDate: toDateValue,
            salaryDate: salaryDateValue,
        }));
        if (requestReimbursementFixedList.length > 0) {
            requestReimbursementFixedList.map(item => {
                item[name] = value;
                item.date = dateValue;
                item.toDate = toDateValue;
            });
            setRequestReimbursementFixedList(requestReimbursementFixedList);
        }
        setRequestReimbursementMileage((prevFormData) => ({
            ...prevFormData,
            [name]: value,
            date: dateValue,
            toDate: toDateValue,
        }));
        setRequestReimbursementExpense((prevFormData) => ({
            ...prevFormData,
            [name]: value,
            date: dateValue,
            toDate: toDateValue,
            dateReceive: dateReceiveValue,
        }));
        if (requestReimbursementExpenseList.length > 0) {
            requestReimbursementExpenseList.map(item => {
                item[name] = value;
                item.date = dateValue;
                item.toDate = toDateValue;
                //item.dateReceive = dateReceiveValue;
            });
            setRequestReimbursementExpenseList(requestReimbursementExpenseList);
        }
    };

    // CHECK REQUIRED INPUTS
    const CheckRequired = () => {
        $("#date").focus();
        $("#orgId").focus();
        $("#purpose").focus();
        $("#costBearerId").focus();
        setTimeout(() => {
            $('.react-datepicker__tab-loop').addClass('d-none');
            $("#date").blur();
            $("#orgId").blur();
            $("#purpose").blur();
            $("#costBearerId").blur();
        },1)
        if (requestReimbursement.date === "" || requestReimbursement.orgId === "" || requestReimbursement.purpose === "" || requestReimbursement.costBearerId === "") {
            return false;
        }
        return true;
    }
    /********************************************* COMMON ********************************************/

    /********************************************* FIXED *********************************************/
    // CHECK IF THERE ARE MORE THAN ONE FIXED
    useEffect(() => {
        if ((requestReimbursement.date && requestReimbursement.date !== "") || deletedFixed === true) {
            // DATE AND TODATE
            if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
                // FORMAT DATES
                const dateFormated = new Date(ChangeDateFormat("date", requestReimbursement.date));
                const toDateFormated = new Date(ChangeDateFormat("date", requestReimbursement.toDate));

                // DIFFERENCE IN SECONDS
                const secondsDifference = toDateFormated.getTime() - dateFormated.getTime();

                // GET DAYS
                const days = (secondsDifference / (1000 * 60 * 60 * 24)) + 1;

                // CHECK IF DAY IS POSITIVE
                if (days > 0) {
                    // MULTIPLE
                    if (days > 1) {
                        // IF THERE ARE MORE FIXEDS THAN DAYS, DELETE THE OUT OF RANGE
                        if (requestReimbursementFixedList.length > days) {
                            // HIDE TOOLTIP ERROR
                            $('#ErrorFormDate').addClass('d-none');
                            setRequestReimbursementFixedList(requestReimbursementFixedList.filter(item => {
                                const itemSalaryDate = new Date(item.salaryDate);
                                if (itemSalaryDate < dateFormated) {
                                    // FIT
                                    //item.salaryDate = itemDate;
                                    // DELETE
                                    return false;
                                }
                                if (itemSalaryDate > toDateFormated) {
                                    // FIT
                                    //item.salaryDate = itemToDate;
                                    // DELETE
                                    return false;
                                }
                                return true;
                            }));
                        }
                        // IF THERE ARE NO FIXEDS CREATE NUMBER OF DAYS
                        else if (requestReimbursementFixedList.length === 0) {
                            // HIDE TOOLTIP ERROR
                            $('#ErrorFormDate').addClass('d-none');
                            const newFixeds = [];
                            for (let i = 0; i < days /*- 1*/; i++) {
                                const tempReimbursement = _.cloneDeep(requestReimbursementFixed);
                                const newSalaryDate = new Date(dateFormated);
                                newSalaryDate.setDate(newSalaryDate.getDate() + i);
                                tempReimbursement.id = null;
                                tempReimbursement.salaryDate = ChangeDateFormat("date", newSalaryDate);
                                tempReimbursement.hours = 0;
                                tempReimbursement.amount = 0;
                                tempReimbursement.type = "Hourly";
                                if (requestReimbursement.costBearerId && requestReimbursement.costBearerId !== "") {
                                    tempReimbursement.costBearerId = requestReimbursement.costBearerId;
                                }
                                if (requestReimbursement.date && requestReimbursement.date !== "") {
                                    tempReimbursement.date = requestReimbursement.date;
                                }
                                if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
                                    tempReimbursement.toDate = requestReimbursement.toDate;
                                }
                                if (requestReimbursement.purpose && requestReimbursement.purpose !== "") {
                                    tempReimbursement.purpose = requestReimbursement.purpose;
                                }
                                newFixeds.push(tempReimbursement);
                            }
                            setRequestReimbursementFixedList((prevFormData) => [
                                ...prevFormData,
                                ...newFixeds
                            ]);
                        }
                        // IF THERE ARE LESS FIXEDS THAN DAYS, ADD THE MISSING
                        else if (requestReimbursementFixedList.length < days) {
                            // HIDE TOOLTIP ERROR
                            $('#ErrorFormDate').addClass('d-none');
                            const existingDates = requestReimbursementFixedList.map(item => new Date(item.salaryDate));
                            existingDates.sort((a, b) => a - b);
                            const lastDate = existingDates[existingDates.length - 1];
                            const firstDate = existingDates[0];
                            const missingFixeds = days - requestReimbursementFixedList.length;
                            const newFixeds = [];
                            if (dateFormated < firstDate) {
                                for (let i = 1; i <= missingFixeds; i++) {
                                    const tempReimbursement = _.cloneDeep(requestReimbursementFixed);
                                    const newSalaryDate = new Date(firstDate);
                                    newSalaryDate.setDate(newSalaryDate.getDate() - i);
                                    tempReimbursement.id = null;
                                    tempReimbursement.salaryDate = ChangeDateFormat("date", newSalaryDate);
                                    tempReimbursement.hours = 0;
                                    tempReimbursement.amount = 0;
                                    tempReimbursement.type = "Hourly";
                                    if (requestReimbursement.costBearerId && requestReimbursement.costBearerId !== "") {
                                        tempReimbursement.costBearerId = requestReimbursement.costBearerId;
                                    }
                                    if (requestReimbursement.date && requestReimbursement.date !== "") {
                                        tempReimbursement.date = requestReimbursement.date;
                                    }
                                    if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
                                        tempReimbursement.toDate = requestReimbursement.toDate;
                                    }
                                    if (requestReimbursement.purpose && requestReimbursement.purpose !== "") {
                                        tempReimbursement.purpose = requestReimbursement.purpose;
                                    }
                                    // ADD FIRST
                                    newFixeds.unshift(tempReimbursement);
                                }
                            } else if (toDateFormated > lastDate) {
                                for (let i = 1; i <= missingFixeds; i++) {
                                    const tempReimbursement = _.cloneDeep(requestReimbursementFixed);
                                    const newSalaryDate = new Date(lastDate);
                                    newSalaryDate.setDate(newSalaryDate.getDate() + i);
                                    tempReimbursement.id = null;
                                    tempReimbursement.salaryDate = ChangeDateFormat("date", newSalaryDate);
                                    tempReimbursement.hours = 0;
                                    tempReimbursement.amount = 0;
                                    tempReimbursement.type = "Hourly";
                                    if (requestReimbursement.costBearerId && requestReimbursement.costBearerId !== "") {
                                        tempReimbursement.costBearerId = requestReimbursement.costBearerId;
                                    }
                                    if (requestReimbursement.date && requestReimbursement.date !== "") {
                                        tempReimbursement.date = requestReimbursement.date;
                                    }
                                    if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
                                        tempReimbursement.toDate = requestReimbursement.toDate;
                                    }
                                    if (requestReimbursement.purpose && requestReimbursement.purpose !== "") {
                                        tempReimbursement.purpose = requestReimbursement.purpose;
                                    }
                                    // ADD LAST
                                    newFixeds.push(tempReimbursement);
                                }
                            }
                            setRequestReimbursementFixedList((prevFormData) => [
                                ...prevFormData,
                                ...newFixeds
                            ]);
                        }
                    }
                    // IF ONY HAVE 1 DAY
                    else {
                        // HIDE TOOLTIP ERROR
                        $('#ErrorFormDate').addClass('d-none');
                        let foundFirst = false;
                        setRequestReimbursementFixedList(requestReimbursementFixedList.filter(item => {
                            if (foundFirst === false) {
                                item.salaryDate = requestReimbursement.date;
                                foundFirst = true;
                                return true;
                            }
                            return false;
                        }));
                    }
                }
                // SHOW TOOLTIP ERROR
                else {
                    $('#ErrorFormDate').removeClass('d-none');
                }
            }
            // ONLY DATE
            else {
                // IF THERE ARE MORE FIXEDS THAN 1 DELETE THE OUT OF RANGE
                if (requestReimbursementFixedList.length > 0) {
                    // HIDE TOOLTIP ERROR
                    $('#ErrorFormDate').addClass('d-none');
                    let foundFirst = false;
                    setRequestReimbursementFixedList(requestReimbursementFixedList.filter(item => {
                        if (foundFirst === false) {
                            item.salaryDate = requestReimbursement.date;
                            foundFirst = true;
                            return true;
                        }
                        return false;
                    }));
                }
                // IF THERE ARE NO FIXEDS CREATE ONE
                else {
                    // HIDE TOOLTIP ERROR
                    $('#ErrorFormDate').addClass('d-none');
                    setRequestReimbursementFixedList([requestReimbursementFixed]);
                }
            }
            // UPDATE DELETE FIXED
            if (deletedFixed) {
                setDeletedFixed(false);
            }
        }
    }, [requestReimbursement.date, requestReimbursement.toDate, deletedFixed, requestReimbursementFixedList[0]?.type]);

    const ToggleFixedError = (selector, hasError, text = null) => {
        if (text !== null) {
            $(selector).text(text);
        }

        if (hasError) {
            $(selector).removeClass("d-none");
            return;
        }
        $(selector).addClass("d-none");
    };

    const GetFixedErrors = ({fixeds = null, fixed = requestReimbursementFixed, isFixedMode = isFixed, minFixedAmount = infoResponse?.hourlySalary?.value || 284}) => {
        const isHourlyMode = isFixedMode === false && fixeds !== null && fixeds.length > 0;
        const hoursSum = isHourlyMode ? fixeds.reduce((sum, item) => sum + (Number(item?.hours) || 0), 0) : 0;
        const fixedAmount = Number(fixed?.amount) || 0;

        const errors = {
            movableAmount: false,
            fixedAmount: false,
            fixedAmountMessage: "",
        };

        if (isHourlyMode) {
            errors.movableAmount = hoursSum <= 0;
            return errors;
        }

        errors.fixedAmount = fixedAmount <= 0 || fixedAmount < minFixedAmount;
        if (fixedAmount > 0 && fixedAmount < minFixedAmount) {
            errors.fixedAmountMessage = t('reimbursement.fixedAmountAtLeast', {amount: minFixedAmount});
        } else {
            errors.fixedAmountMessage = t('validationMessage.greater0');
        }

        return errors;
    };

    const HandleTooltipErrorFixed = ({fixeds = null, fixed = requestReimbursementFixed, isFixedMode = isFixed} = {}) => {
        const minFixedAmount = infoResponse?.hourlySalary?.value || 284;
        const errors = GetFixedErrors({fixeds, fixed, isFixedMode, minFixedAmount});

        if (isFixedMode === false && fixeds !== null && fixeds.length > 0) {
            ToggleFixedError("#errorMovableAmount", errors.movableAmount);
            ToggleFixedError("#errorFixedAmount", false);
            return errors;
        }

        ToggleFixedError("#errorMovableAmount", false);
        ToggleFixedError("#errorFixedAmount", errors.fixedAmount, errors.fixedAmountMessage);
        return errors;
    };

    // HANDLE CHANGE FIXED
    const HandleChangeFixed = (e, name, index = null, isFixedValue = null) => {
        setCheckUnsaved(true);
        let hoursValue = 0;
        let typeValue = "";
        let amountValue = 0;
        if (index !== null) {
            setIsFixed(false);
            hoursValue = requestReimbursementFixedList[index].hours;
            typeValue = requestReimbursementFixedList[index].type;
            amountValue = requestReimbursementFixedList[index].amount;
        } else if (isFixedValue !== null) {
            setIsFixed(true);
            hoursValue = requestReimbursementFixed.hours;
            typeValue = requestReimbursementFixed.type;
            amountValue = requestReimbursementFixed.amount;
        }
        switch (name) {
            case "hours":
                typeValue = "Hourly";
                hoursValue = 0;
                amountValue = 0;
                if (e?.target?.value && e?.target?.value !== "") {
                    hoursValue = CheckDecimal(e.target.value);
                    if (infoResponse && infoResponse.hourlySalary) {
                        amountValue = (hoursValue <= 16 ? hoursValue : 16) * infoResponse.hourlySalary.value;
                    }
                }
                break;
            case "amount":
                typeValue = "Fixed";
                hoursValue = null;
                amountValue = 0;
                if (e?.target?.value && e?.target?.value !== "") {
                    amountValue = CheckDecimal(e.target.value);
                }
                break;
            case "fixed":
                setIsFixed(true);
                typeValue = "Fixed";
                hoursValue = null;
                amountValue = 0;
                break;
            case "hourly":
                setIsFixed(false);
                typeValue = "Hourly";
                if (requestReimbursementFixed.hours && requestReimbursementFixed.hours !== 0) {
                    hoursValue = 0;
                    amountValue = 0;
                }
                break;
        }
        if (typeValue !== "") {
            if (index !== null && !isFixed) {
                const nextFixedList = requestReimbursementFixedList.map((item, idx) => idx === index ? {
                        ...item,
                        hours: hoursValue,
                        type: typeValue,
                        amount: amountValue
                    } : item);
                setRequestReimbursementFixedList(nextFixedList);
                HandleTooltipErrorFixed({fixeds: nextFixedList, isFixedMode: false});
            } else if (isFixedValue !== null && isFixed) {
                const nextFixedData = {
                    ...requestReimbursementFixed,
                    hours: hoursValue,
                    type: typeValue,
                    amount: amountValue,
                };
                setRequestReimbursementFixed(nextFixedData);
                HandleTooltipErrorFixed({fixed: nextFixedData, isFixedMode: typeValue === "Fixed"});
            }
        }
    };

    // VALIDATE FIXED
    const HandleValidateFixed = async (fixeds = null) => {
        try {
            const isHourlyMode = isFixed === false && fixeds !== null && fixeds.length > 0;

            if (CheckRequired()) {
                const errors = HandleTooltipErrorFixed({
                    fixeds,
                    fixed: requestReimbursementFixed,
                    isFixedMode: !isHourlyMode,
                });

                if (isHourlyMode) {
                    if (errors.movableAmount) {
                        return false;
                    }

                    const fixedPayload = fixeds.map(item => ({
                        ...item,
                        status: "Förslag",
                    }));

                    await Promise.all(
                        fixedPayload.map(async (item) => {
                            return completeSchemaFixed.validate(item, {abortEarly: false});
                        })
                    );

                    setWasAddedFixed(false);
                    setRequestReimbursementFixedList(fixedPayload);
                    // DISABLE DATE AND TO DATE INPUTS
                    $("#date, #toDate, #checkInput").prop("disabled", true);
                    setDisplayFixed(false);
                    setEditModeFixed(false);
                    return true;
                } else {
                    if (errors.fixedAmount) {
                        return false;
                    }

                    const fixedPayload = {
                        ...requestReimbursementFixed,
                        status: "Förslag",
                        salaryDate: requestReimbursement.date,
                    };

                    await completeSchemaFixed.validate(fixedPayload, {abortEarly: false});

                    setWasAddedFixed(true);
                    setRequestReimbursementFixed(fixedPayload);
                    setRequestReimbursementFixedList([fixedPayload]);
                    // DISABLE DATE AND TO DATE INPUTS
                    $("#date, #toDate, #checkInput").prop("disabled", true);
                    setDisplayFixed(false);
                    setEditModeFixed(false);
                    return true;
                }
            } else {
                HandleTooltipErrorFixed({
                    fixeds,
                    fixed: requestReimbursementFixed,
                    isFixedMode: !isHourlyMode,
                });
                return false;
            }
        } catch (error) {
            HandleTooltipErrorFixed({
                fixeds,
                fixed: requestReimbursementFixed,
                isFixedMode: !(isFixed === false && fixeds !== null && fixeds.length > 0),
            });
            return false;
        }
    }

    // HANDLE CANCEL FORMS
    const HandleCancelFixed = (fixeds, fixed) => {
        // RELOAD OLD VALUES IN DATE AND TO DATE
        let dateValue = requestReimbursement.date;
        let toDateValue = requestReimbursement.toDate;
        if (wasAddedFixed === true) {
            dateValue = fixed.date;
            if (fixed.toDate && fixed.toDate !== "") {
                toDateValue = fixed.toDate;
            } else {
                toDateValue = null;
            }
            setRequestReimbursement((prevFormData) => ({
                ...prevFormData,
                date: dateValue,
                toDate: toDateValue,
            }));
            setRequestReimbursementFixed(fixed);
            setRequestReimbursementMileage((prevFormData) => ({
                ...prevFormData,
                date: dateValue,
                toDate: toDateValue,
            }));
            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                date: dateValue,
                toDate: toDateValue,
            }));
            if (requestReimbursementExpenseList.length > 0) {
                requestReimbursementExpenseList.map(item => {
                    item.date = dateValue;
                    item.toDate = toDateValue;
                });
                setRequestReimbursementExpenseList(requestReimbursementExpenseList);
            }
        } else {
            if (fixeds.length > 0) {
                dateValue = fixeds[0].date;
                if (fixeds[0].toDate && fixeds[0].toDate !== "") {
                    toDateValue = fixeds[0].toDate;
                } else {
                    toDateValue = null;
                }
                setRequestReimbursement((prevFormData) => ({
                    ...prevFormData,
                    date: dateValue,
                    toDate: toDateValue,
                }));
                setRequestReimbursementFixedList(fixeds);
                setRequestReimbursementMileage((prevFormData) => ({
                    ...prevFormData,
                    date: dateValue,
                    toDate: toDateValue,
                }));
                setRequestReimbursementExpense((prevFormData) => ({
                    ...prevFormData,
                    date: dateValue,
                    toDate: toDateValue,
                }));
                if (requestReimbursementExpenseList.length > 0) {
                    requestReimbursementExpenseList.map(item => {
                        item.date = dateValue;
                        item.toDate = toDateValue;
                    });
                    setRequestReimbursementExpenseList(requestReimbursementExpenseList);
                }
            }
        }
        setDisplayFixed(false);
        setEditModeFixed(false);
        setIsFixed(wasAddedFixed);
        setTimeout(() => {
            $("#date, #toDate, #checkInput").prop("disabled", true);
        },100);
    }
    /********************************************* FIXED *********************************************/

    /********************************************* MILEAGE *******************************************/
    const ToggleMileageError = (selector, hasError) => {
        if (hasError) {
            $(selector).removeClass('d-none');
            return;
        }
        $(selector).addClass('d-none');
    };

    const GetMileageErrors = (mileageData) => {
        const hasPassengers = mileageData?.passengers !== null && Array.isArray(mileageData?.passengers) && mileageData.passengers.length > 0;
        const passenger = hasPassengers ? mileageData.passengers[0] : null;

        return {
            from: mileageData?.from === "",
            to: mileageData?.to === "",
            km: mileageData?.km === "" || mileageData?.km === 0,
            quantityPassenger: hasPassengers ? passenger?.quantity === "" || passenger?.quantity === 0 : false,
            kmPassenger: hasPassengers ? passenger?.km === "" || passenger?.km === 0 : false,
        };
    };

    const HandleTooltipErrorMileage = (mileageData = requestReimbursementMileage, fieldName = null) => {
        const errors = GetMileageErrors(mileageData);
        const hasPassengers = mileageData?.passengers !== null && Array.isArray(mileageData?.passengers) && mileageData.passengers.length > 0;

        if (fieldName !== null) {
            switch (fieldName) {
                case "from":
                    ToggleMileageError('#errorFrom', errors.from);
                    break;
                case "to":
                    ToggleMileageError('#errorTo', errors.to);
                    break;
                case "km":
                    ToggleMileageError('#errorKm', errors.km);
                    break;
                case "quantityPassenger":
                    if (hasPassengers) {
                        ToggleMileageError('#errorQuantityPassenger', errors.quantityPassenger);
                    } else {
                        ToggleMileageError('#errorQuantityPassenger', false);
                    }
                    break;
                case "kmPassenger":
                    if (hasPassengers) {
                        ToggleMileageError('#errorKmPassenger', errors.kmPassenger);
                    } else {
                        ToggleMileageError('#errorKmPassenger', false);
                    }
                    break;
                case "addPassenger":
                case "cancelPassenger":
                    ToggleMileageError('#errorQuantityPassenger', false);
                    ToggleMileageError('#errorKmPassenger', false);
                    break;
                case "swap":
                    ToggleMileageError('#errorFrom', errors.from);
                    ToggleMileageError('#errorTo', errors.to);
                    break;
            }

            return errors;
        }

        ToggleMileageError('#errorFrom', errors.from);
        ToggleMileageError('#errorTo', errors.to);
        ToggleMileageError('#errorKm', errors.km);

        if (hasPassengers) {
            ToggleMileageError('#errorQuantityPassenger', errors.quantityPassenger);
            ToggleMileageError('#errorKmPassenger', errors.kmPassenger);
        } else {
            ToggleMileageError('#errorQuantityPassenger', false);
            ToggleMileageError('#errorKmPassenger', false);
        }

        return errors;
    }

    // HANDLE CHANGE MILEAGE
    const HandleChangeMileage = (e, name) => {
        setCheckUnsaved(true);
        let value = e?.target?.value && e?.target?.value !== "" ? e.target.value : "";
        let amountValue = requestReimbursementMileage.amount;
        let passengersValue = requestReimbursementMileage.passengers ? [...requestReimbursementMileage.passengers] : null;
        let quantityPassengerValue = requestReimbursementMileage.passengers && Array.isArray(requestReimbursementMileage.passengers) && requestReimbursementMileage.passengers.length > 0 ? requestReimbursementMileage.passengers[0].quantity : 0;
        let kmPassengerValue = requestReimbursementMileage.passengers && Array.isArray(requestReimbursementMileage.passengers) && requestReimbursementMileage.passengers.length > 0 ? requestReimbursementMileage.passengers[0].km : 0;
        let amountPassengerValue = requestReimbursementMileage.passengers && Array.isArray(requestReimbursementMileage.passengers) && requestReimbursementMileage.passengers.length > 0 ? requestReimbursementMileage.passengers[0].amount : 0;
        let totalAmountValue = requestReimbursementMileage.totalAmount;
        switch (name) {
            case "km":
                value = 0;
                amountValue = 0;
                if (e && e.target && e?.target?.value !== "") {
                    value = CheckDecimal(e.target.value);
                    if (infoResponse?.payableTravelPer10km) {
                        const calculateAmount = (value * infoResponse.payableTravelPer10km.value) / 10;
                        amountValue = parseFloat(calculateAmount.toFixed(2));
                    }
                }
                break;
            case "addPassenger":
                passengersValue = [];
                break;
            case "cancelPassenger":
                passengersValue = null;
                quantityPassengerValue = 0;
                kmPassengerValue = 0;
                break;
            case "quantityPassenger":
                quantityPassengerValue = e?.target?.value && e?.target?.value !== "" ? CheckDecimal(e.target.value) : 0;
                break;
            case "kmPassenger":
                kmPassengerValue = e?.target?.value && e?.target?.value !== "" ? CheckDecimal(e.target.value) : 0;
                break;
            case "swap":
                const fromVal = requestReimbursementMileage.from;
                const toVal = requestReimbursementMileage.to;
                setRequestReimbursementMileage((prevFormData) => ({
                    ...prevFormData,
                    from: toVal,
                    to: fromVal,
                }));
                HandleTooltipErrorMileage({
                    ...requestReimbursementMileage,
                    from: toVal,
                    to: fromVal,
                }, "swap");
                return;
        }

        totalAmountValue = amountValue;
        if (passengersValue && infoResponse?.payableTravelPassangerPer10km) {
            const calculateAmount = kmPassengerValue * infoResponse.payableTravelPassangerPer10km.value;
            let totalAmount = calculateAmount / 10;
            amountPassengerValue = parseFloat(totalAmount.toFixed(2));
            totalAmountValue = amountValue + amountPassengerValue;
            passengersValue[0] = {
                quantity: quantityPassengerValue,
                km: kmPassengerValue,
                amount: amountPassengerValue,
            };
        }
        if (name === "addPassenger" || name === "cancelPassenger" || name === "quantityPassenger" || name === "kmPassenger") {
            setRequestReimbursementMileage((prevFormData) => ({
                ...prevFormData,
                amount: amountValue,
                passengers: passengersValue,
                totalAmount: totalAmountValue,
            }));
        }
        else {
            setRequestReimbursementMileage((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                amount: amountValue,
                passengers: passengersValue,
                totalAmount: totalAmountValue,
            }));
        }

        const nextMileageData = {
            ...requestReimbursementMileage,
            ...(name === "addPassenger" || name === "cancelPassenger" || name === "quantityPassenger" || name === "kmPassenger" ? {} : {[name]: value}),
            amount: amountValue,
            passengers: passengersValue,
            totalAmount: totalAmountValue,
        };
        HandleTooltipErrorMileage(nextMileageData, name);
    };

    // VALIDATE MILEAGE
    const HandleValidateMileage = async () => {
        try {
            if (CheckRequired()) {
                const errors = HandleTooltipErrorMileage(requestReimbursementMileage);
                const hasMileageErrors = Object.values(errors).some(Boolean);
                if (hasMileageErrors) {
                    return false;
                }

                const mileagePayload = {
                    ...requestReimbursementMileage,
                    status: "Förslag",
                };

                await completeSchemaMileage.validate(mileagePayload, {abortEarly: false});
                if (mileagePayload.passengers !== null && mileagePayload.passengers.length > 0) {
                    await completeSchemaPassenger.validate(mileagePayload.passengers[0], {abortEarly: false});
                }

                setRequestReimbursementMileage(mileagePayload);
                setDisplayMileage(false);
                setEditModeMileage(false);
                return true;
            }
            HandleTooltipErrorMileage();
            return false;
        } catch (error) {
            HandleTooltipErrorMileage();
            return false;
        }
    }

    // CANCEL MILEAGE
    const HandleCancelMileage = (mileage) => {
        setRequestReimbursementMileage(mileage);
        setDisplayMileage(false);
        setEditModeMileage(false);
    }
    /********************************************* MILEAGE *******************************************/

    /********************************************* EXPENSE *******************************************/

    const HandleUploadFile = async (e, setFileResponse, fileInfo, id = null) => {
        const formData = new FormData();
        let isValidFile = false;
        e.map(item => {
            if (item.size > MAX_FILE_SIZE_BYTES) {
                FlashMessage(t('validationMessage.maxSizeFile'), 'flash-messageWarning');
            return;
        }
            if (item.type === 'image/png' || item.type === 'image/jpg' || item.type === 'image/gif' || item.type === 'image/jpeg' || item.type === "application/pdf" || item.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || item.type === "application/msword" || item.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || item.type === "application/vnd.ms-excel" || item.type === "text/plain") {
                formData.append('file', item);
                isValidFile = true;
                
                if (fileInfo === "fileId") {
                    setRequestReimbursementExpense((prevFormData) => ({
                        ...prevFormData,
                        fileExtension: item.type,
                        fileName: item.name,
                    }));
                } else {
                    setRequestReimbursementExpense((prevFormData) => ({
                        ...prevFormData,
                        additionalFileExtension: item.type,
                        additionalFileName: item.name,
                    }));

                    if (id !== null) {
                        setUploadTarget({ id: id, fieldName: fileInfo, expenseIndex: editModeExpense ? expenseIndex : null });
                        setTempAdditionalInfoList(prevData => prevData.map(dataItem => {
                        //setRequestAdditionalInfoList(prevData => prevData.map(dataItem => {
                            if (IsInSameDocumentGroup(prevData, dataItem, id)) {
                                return {
                                    ...dataItem,
                                    additionalFileName: item.name,
                                    additionalFileExtension: item.type,
                                };
                            }
                            return dataItem;
                        }));
                    }
                }
            }
        });

        if (isValidFile) {
                const apiCallOptions = {
                    method: "post",
                    url: "/file",
                    data: formData,
                    dataTypes: "file"
                };
                try {
                    await ApiCall(apiCallOptions, setFileResponse);
                } catch (error) {
                    //console.log({error});
                }
            } else {
                setFileResponse(null);
            }
    };

    useEffect(() => {
        if (fileResponse !== null) {

            if (fileType === "fileId") {
                setRequestReimbursementExpense((prevFormData) => ({
                    ...prevFormData,
                    [fileType]: fileResponse.id,
                }));
            } 
            else {
                setRequestReimbursementExpense((prevFormData) => ({
                    ...prevFormData,
                    additionalInfo: {
                        ...prevFormData.additionalInfo,
                        [fileType]: fileResponse.id
                    }
                }));
                
                if (uploadTarget.id) {
                    const newFileId = fileResponse.id;
                    // The file is shared by every entry with the same required documentation
                    // (matching by index is not safe: the expense list is re-sorted by date)
                    setTempAdditionalInfoList(prevData => prevData.map((item) => {
                        if (IsInSameDocumentGroup(prevData, item, uploadTarget.id)) {
                            const updatedAdditionalInfo = {
                                ...item.additionalInfo,
                                [fileType]: newFileId,
                            };
                            return { ...item, additionalInfo: updatedAdditionalInfo };
                        }
                        return item;
                    }));
                    setUploadTarget({ id: null, fieldName: null, expenseIndex: null });
                }
            }
        }
    }, [fileResponse]);

    // DELETE FILE FROM REQUEST
    useEffect(() => {
        if (isDeletedFile === true) {
            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                fileId: "",
                fileExtension: "",
                fileName: "",
            }));
            setIsDeletedFile(false);
        }
    }, [isDeletedFile]);

    // DELETE EXTRA FILE FROM REQUEST
    useEffect(() => {
        if (isDeletedExtraFile === true) {
            const fileTypeId = fileType;
            const fieldValue = requestReimbursementExpense.additionalInfo?.[fileTypeId]

            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                additionalInfo: {
                    ...prevFormData.additionalInfo,
                    [fileType]: ""
                },
                additionalFileExtension: "",
                additionalFileName: "",
            }));
            setIsDeletedExtraFile(false);
            
            const updatedAdditionalInfoList = requestAdditionalInfoList.map((item) => {
                if (item.additionalInfo?.[fileTypeId] === fieldValue) {
                    return {
                        ...item,
                        additionalInfo: {
                            ...item.additionalInfo,
                            [fileTypeId]: ""
                        }
                    };
                }             
                return item;
            });

            const updatedAdditionalInfoListTemp = tempAdditionalInfoList.map((item) => {
                if (item.additionalInfo?.[fileTypeId] === fieldValue) {
                    return {
                        ...item,
                        additionalInfo: {
                            ...item.additionalInfo,
                            [fileTypeId]: ""
                        }
                    };
                }             
                return item;
            });
        setTempAdditionalInfoList(updatedAdditionalInfoListTemp);
        setRequestAdditionalInfoList(updatedAdditionalInfoList);
        }
    }, [isDeletedExtraFile]);

    // HANDLE CHANGE EXPENSE
    const HandleChangeExpense = async (e, name, extraFieldName = null) => {
        setCheckUnsaved(true);

        let updatedFields = {};
        switch (name) {
            case "fileId":
                await HandleUploadFile(e, setFileResponse, "fileId");
                setFileType("fileId");
                return;
            case "dateReceive":
                updatedFields.dateReceive = ChangeDateFormat('date', e);
                break;
            case "amount":
                updatedFields.amount = e?.target?.value ? CheckDecimal(e.target.value) : 0;
                break;
            case "vatAmount":
                updatedFields.vatAmount = e?.target?.value ? CheckDecimal(e.target.value) : '';
                break;
            case "accountingId":
                // const accountingId = e.target.value;
                // updatedFields.accountingId = accountingId;

                // if (infoResponse.accountings?.length) {
                //     const found = infoResponse.accountings.find(item => item.id === accountingId);
                //     if (found) updatedFields.accountingName = found.showLabel;
                // }

                // if (infoResponse.accountingsExtraFields?.length) {
                //     const foundExtra = infoResponse.accountingsExtraFields.find(item => item.accountingId === accountingId);
                //     if (foundExtra) {
                //         const extraFields = foundExtra.extraFields;
                //         if (extraFields.length > 0) {
                //             let newAdditionalInfo = {};
                //             const field1 = StringToLowerCaseFirst(extraFields[0].requestName);
                //             newAdditionalInfo[field1] = requestReimbursementExpense.additionalInfo?.[field1] ?? "";
                //             setRequestName(field1);
                //             setExtraField(extraFields[0]);

                //             if (extraFields.length > 1) {
                //                 const field2 = StringToLowerCaseFirst(extraFields[1].requestName);
                //                 newAdditionalInfo[field2] = requestReimbursementExpense.additionalInfo?.[field2] ?? "";
                //                 setRequestName2(field2);
                //                 setExtraField2(extraFields[1]);
                //             }

                //             updatedFields.additionalInfo = newAdditionalInfo;
                //         } else {
                //             updatedFields.additionalInfo = null;
                //         }
                //     }
                // }

                // break;
                const newAccountingId = e.target.value;
                updatedFields.accountingId = newAccountingId;
                if (infoResponse.accountings?.length) {
                    const found = infoResponse.accountings.find(item => item.id === newAccountingId);
                    if (found) {
                        updatedFields.accountingName = found.showLabel;
                        const docs = found.requiredDocumentation ?? found.requiredDocuments ?? [];
                        updatedFields.requiredDocumentation = Array.isArray(docs) ? docs : [];
                    }
                }

                const foundExtra = infoResponse.accountingsExtraFields?.find(item => item.accountingId === newAccountingId);
                
                if (foundExtra && foundExtra.extraFields.length > 0) {
                    let newAdditionalInfo = {};
                    foundExtra.extraFields.forEach(field => {
                        const fieldName = StringToLowerCaseFirst(field.requestName);
                        newAdditionalInfo[fieldName] = "";
                    });
                    updatedFields.additionalInfo = newAdditionalInfo;
                } else {
                    updatedFields.additionalInfo = null; 
                    updatedFields.additionalFileName = "";
                    updatedFields.additionalFileExtension = "";
                }
                updatedFields.selectedRadioOption = null;
            break;
            case "dynamic":
                if (Array.isArray(e)) {
                    if (extraFieldName) {
                        setFileType(extraFieldName);
                    }
                    setTimeout(() => {
                        HandleUploadFile(e, setFileResponse, "dynamic");
                    }, 500);
                } else {
                    const program = e.target.value;
                    updatedFields.additionalInfo = {
                        ...requestReimbursementExpense.additionalInfo,
                        program,
                    };
                }
                break;
            case "radio":
                const value = e?.target?.value;
                if (value === "option1") {
                    updatedFields.additionalInfo = {
                        ...requestReimbursementExpense.additionalInfo,
                        program: "",
                        participantsFileId: null,
                    };
                    updatedFields.additionalFileExtension = "";
                    updatedFields.additionalFileName = "";
                } else {
                    updatedFields.additionalInfo = {
                        ...requestReimbursementExpense.additionalInfo,
                        program: null,
                        participantsFileId: "",
                    };
                }
                break;
         case "additionalInfoFileId":
                const additionalInfoFileId = e?.target?.value;
                const additionalFileExtension = e?.target?.fileExtension;

                if (additionalInfoFileId !== "" && 
                    additionalInfoFileId !== null && 
                    additionalInfoFileId !== undefined && 
                    additionalInfoFileId !== "option1" && 
                    additionalInfoFileId !== "option2") {
                        updatedFields.additionalInfo = {
                            ...requestReimbursementExpense.additionalInfo,
                            program: null,
                            participantsFileId: additionalInfoFileId,
                        };
                        updatedFields.additionalFileExtension = additionalFileExtension;
                    }
                break;
            case "additionalInfoProgramFileId":
                const additionalInfoProgramFileId = e?.target?.value;
                const additionalInfoProgram = e?.target?.valueProgram;
                const additionalInfoFileExtension = e?.target?.fileExtension;

                if (additionalInfoProgramFileId !== "" && 
                    additionalInfoProgramFileId !== null && 
                    additionalInfoProgramFileId !== undefined) {
                        updatedFields.additionalInfo = {
                            ...requestReimbursementExpense.additionalInfo,
                            program: additionalInfoProgram,
                            programFileId: additionalInfoProgramFileId,
                        };
                        updatedFields.additionalFileExtension = additionalInfoFileExtension;
                    }
                break;
            case "dynamicLastExpense":
                if (Array.isArray(e)) {
                    if (extraFieldName) {
                        setFileType(extraFieldName);
                    }
                    setTimeout(() => {
                        HandleUploadFile(e, setFileResponse, "dynamic");
                    }, 500);
                } else {
                    const program = e.target.value;
                    updatedFields.additionalInfo = {
                        ...requestReimbursementExpense.additionalInfo,
                        program,
                        participantsFileId: null,
                    };
                }
                break;
        }

        if (name === "accountingId" && infoResponse.accountingsIva?.length) {
            const isAccountingWithNoVat = infoResponse.accountingsIva.some(item => item.accountingId === updatedFields.accountingId);
            if (isAccountingWithNoVat) {
                updatedFields.vatAmount = null;
            } else {
                updatedFields.vatAmount = requestReimbursementExpense.vatAmount ?? '';
            }
        }

        setRequestReimbursementExpense(prev => ({
            ...prev,
            ...updatedFields,
        }));

        // const idAlreadyExists = requestAdditionalInfoList.some(
        //     item => item.accountingId === requestReimbursementExpense.accountingId
        // );
        // console.log({idAlreadyExists});
        // if (!idAlreadyExists) {
        //     setRequestAdditionalInfo({
        //         additionalInfo: {},
        //         additionalFileExtension: '',
        //         additionalFileName: '',
        //         accountingId: requestReimbursementExpense.accountingId,
        //         accountingName: requestReimbursementExpense.accountingName,
        //     });
        // }        
        if (name === "accountingId") {
            const newAccountingId = updatedFields.accountingId;
            const newAccountingName = updatedFields.accountingName;
            const foundExtra = infoResponse.accountingsExtraFields?.find(item => item.accountingId === newAccountingId);
            const requiredDocumentation = updatedFields.requiredDocumentation || [];
            
            let extraFieldsData = {};
            if (foundExtra && foundExtra.extraFields.length > 0) {
                foundExtra.extraFields.forEach(field => {
                    const fieldName = StringToLowerCaseFirst(field.requestName);
                    extraFieldsData[fieldName] = ""; 
                });
            }

            const newAdditionalInfo = {
                accountingId: newAccountingId,
                accountingName: newAccountingName,
                additionalInfo: extraFieldsData,
                additionalFileName: '', 
                additionalFileExtension: '',
                requiredDocumentation: requiredDocumentation,
            };

            setRequestAdditionalInfo(newAdditionalInfo);
        }
    };

    // VALIDATE EXPENSE
    const HandleValidateExpense = async () => {
        let exit = false;
    
        if (exit === false) {
            try {
                if (CheckRequired()) {
                    requestReimbursementExpense.status = "Förslag";
                    if (requestReimbursementExpense.vatAmount >= 0 || requestReimbursementExpense.vatAmount === null) {
                        if (requestReimbursementExpense.amount > requestReimbursementExpense.vatAmount) {
                            await completeSchemaExpense.validate(requestReimbursementExpense, {abortEarly: false});

                            let updatedExpenseList = requestReimbursementExpenseList;

                            if (editModeExpense === true) {
                                const originalExpense = requestReimbursementExpenseList[expenseIndex];
                                const oldAccountingId = originalExpense?.accountingId;
                                const newAccountingId = requestReimbursementExpense.accountingId;
                                
                                updatedExpenseList = requestReimbursementExpenseList.map((item, i) => {
                                    if (i === expenseIndex) {
                                        return requestReimbursementExpense;
                                    } else {
                                        return item;
                                    }
                                });

                                setRequestReimbursementExpenseList(updatedExpenseList);
                                
                                if (oldAccountingId !== newAccountingId) {
                                    const countOldAccounting = requestReimbursementExpenseList.filter(
                                        (expense, idx) => expense.accountingId === oldAccountingId && idx !== expenseIndex
                                    ).length;

                                    const existingExpenseWithNewAccounting = requestReimbursementExpenseList.find(
                                        (expense, idx) => expense.accountingId === newAccountingId && idx !== expenseIndex
                                    );

                                    let existingAdditionalInfo = null;
                                    if (existingExpenseWithNewAccounting) {
                                        existingAdditionalInfo = tempAdditionalInfoList.find(
                                            item => item.accountingId === newAccountingId
                                        );
                                    }
                                    // Another expense (other accounting) with the same required documentation already has the list
                                    if (!existingAdditionalInfo && requestAdditionalInfo) {
                                        const newGroupKey = GetDocumentGroupKey(requestAdditionalInfo);
                                        const groupSibling = tempAdditionalInfoList.find(
                                            item => GetDocumentGroupKey(item) === newGroupKey && HasFilledAdditionalInfo(item)
                                        );
                                        if (groupSibling) {
                                            existingAdditionalInfo = {
                                                ...requestAdditionalInfo,
                                                ...GetSharedGroupValues(groupSibling),
                                                additionalInfo: { ...(requestAdditionalInfo.additionalInfo || {}), ...(groupSibling.additionalInfo || {}) },
                                            };
                                        }
                                    }

                                    const oldInfoItem = !existingAdditionalInfo 
                                        ? tempAdditionalInfoList.find(item => item.accountingId === oldAccountingId)
                                        : null;

                                    const buildInfoWithConservedValues = (baseInfo) => {
                                        if (!oldInfoItem || !baseInfo) return baseInfo;

                                        const newRequiredDocs = baseInfo.requiredDocumentation || [];
                                        const oldRequiredDocs = oldInfoItem.requiredDocumentation || [];

                                        const hasCommonRequirements = newRequiredDocs.some(
                                            req => oldRequiredDocs.includes(req)
                                        );

                                        if (!hasCommonRequirements) return baseInfo;

                                        const conservedAdditionalInfo = { ...baseInfo.additionalInfo };
                                        if (oldInfoItem.additionalInfo) {
                                            Object.keys(conservedAdditionalInfo).forEach(fieldName => {
                                                const oldValue = oldInfoItem.additionalInfo[fieldName];
                                                if (oldValue && oldValue !== "") {
                                                    conservedAdditionalInfo[fieldName] = oldValue;
                                                }
                                            });
                                        }

                                        let derivedRadioOption = null;
                                        if (conservedAdditionalInfo.program !== undefined &&
                                            conservedAdditionalInfo.program !== null &&
                                            conservedAdditionalInfo.program !== "") {
                                            derivedRadioOption = "option1";
                                        } else if (conservedAdditionalInfo.participantsFileId !== undefined &&
                                                conservedAdditionalInfo.participantsFileId !== null &&
                                                conservedAdditionalInfo.participantsFileId !== "") {
                                            derivedRadioOption = "option2";
                                        }

                                        return {
                                            ...baseInfo,
                                            additionalInfo: conservedAdditionalInfo,
                                            additionalFileName: oldInfoItem.additionalFileName || baseInfo.additionalFileName,
                                            additionalFileExtension: oldInfoItem.additionalFileExtension || baseInfo.additionalFileExtension,
                                            selectedRadioOption: derivedRadioOption || null,
                                        };
                                    };

                                    setTempAdditionalInfoList((prevList) => {
                                        if (!requestAdditionalInfo) {
                                            return prevList;
                                        }

                                        const baseInfo = existingAdditionalInfo
                                            ? { ...existingAdditionalInfo }
                                            : requestAdditionalInfo;

                                        const infoForNew = buildInfoWithConservedValues(baseInfo);

                                        // We replace ONE entry of the old accounting with the new one,
                                        // so that "one is changed for the other" and it is not deleted.
                                        const indexToReplace = prevList.findIndex(
                                            item => item.accountingId === oldAccountingId
                                        );

                                        // If we don't find anything from the old accounting, we add the new info.
                                        if (indexToReplace === -1) {
                                            return [
                                                ...prevList,
                                                {
                                                    ...infoForNew,
                                                    accountingId: newAccountingId,
                                                    accountingName: requestReimbursementExpense.accountingName,
                                                }
                                            ];
                                        }

                                        const updatedList = [...prevList];
                                        updatedList[indexToReplace] = {
                                            ...infoForNew,
                                            accountingId: newAccountingId,
                                            accountingName: requestReimbursementExpense.accountingName,
                                        };

                                        return updatedList;
                                    });

                                    setRequestAdditionalInfoList((prevList) => {
                                        if (!requestAdditionalInfo) {
                                            return prevList;
                                        }

                                        const baseInfo = existingAdditionalInfo
                                            ? { ...existingAdditionalInfo }
                                            : requestAdditionalInfo;

                                        const infoForNew = buildInfoWithConservedValues(baseInfo);

                                        const indexToReplace = prevList.findIndex(
                                            item => item.accountingId === oldAccountingId
                                        );

                                        if (indexToReplace === -1) {
                                            return [
                                                ...prevList,
                                                {
                                                    ...infoForNew,
                                                    accountingId: newAccountingId,
                                                    accountingName: requestReimbursementExpense.accountingName,
                                                }
                                            ];
                                        }

                                        const updatedList = [...prevList];
                                        updatedList[indexToReplace] = {
                                            ...infoForNew,
                                            accountingId: newAccountingId,
                                            accountingName: requestReimbursementExpense.accountingName,
                                        };

                                        return updatedList;
                                    });
                                } else {
                                    // Accounting did not change, just update the data
                                    // Replace the entry of this accounting (not by index: the expense list is re-sorted by date,
                                    // so expenseIndex may point to the entry of another accounting)
                                    if (requestAdditionalInfo && requestAdditionalInfo.accountingId) {
                                        const replaceEntryOfAccounting = (prevList) => {
                                            const indexToReplace = prevList.findIndex(
                                                item => item.accountingId === requestAdditionalInfo.accountingId
                                            );
                                            if (indexToReplace === -1) {
                                                return [...prevList, requestAdditionalInfo];
                                            }
                                            return prevList.map((item, i) => (i === indexToReplace ? requestAdditionalInfo : item));
                                        };

                                        setTempAdditionalInfoList(replaceEntryOfAccounting);

                                        // Also update requestAdditionalInfoList when accounting does not change
                                        setRequestAdditionalInfoList(replaceEntryOfAccounting);
                                    }
                                }
                                
                                setExpenseIndex(null);
                            } else {
                                // CREATION MODE
                                requestReimbursementExpense.temporalId = Date.now();

                                updatedExpenseList = [
                                    ...requestReimbursementExpenseList,
                                    requestReimbursementExpense
                                ];

                                setRequestReimbursementExpenseList(updatedExpenseList);

                                if (requestAdditionalInfo && requestAdditionalInfo.accountingId) {
                                    
                                    
                                    infoResponse.accountingsExtraFields.map((value, index) => {
                                        if(value.accountingId === requestAdditionalInfo.accountingId) {
                                            value.extraFields.map((extraField, extraIndex) => {
                                                requestAdditionalInfo.additionalInfo[StringToLowerCaseFirst(extraField.requestName)] =  "";
                                            });
                                        }
                                    });
                                    setTempAdditionalInfoList(prevList => {
                                    //setRequestAdditionalInfoList(prevList => [
                                        // Reuse the list/attachment already entered for an expense with the same required
                                        // documentation (same or different accounting) instead of adding an empty entry
                                        const newGroupKey = GetDocumentGroupKey(requestAdditionalInfo);
                                        const sameGroup = prevList.filter(item => GetDocumentGroupKey(item) === newGroupKey);
                                        const existingInfo = sameGroup.find(item => HasFilledAdditionalInfo(item)) || sameGroup[0];
                                        if (!existingInfo) {
                                            return [...prevList, requestAdditionalInfo];
                                        }
                                        const shared = GetSharedGroupValues(existingInfo);
                                        return [
                                            ...prevList,
                                            {
                                                ...requestAdditionalInfo,
                                                ...shared,
                                                additionalInfo: { ...requestAdditionalInfo.additionalInfo, ...shared.additionalInfo },
                                            }
                                        ];
                                    });
                                }
                            }

                            if (updatedExpenseList && updatedExpenseList.length > 0) {
                                const sortByExpenseIndex = (list) => {
                                    if (!list || list.length === 0) return list;

                                    const sorted = [...list].sort((a, b) => {
                                        const indexA = updatedExpenseList.findIndex(
                                            (expense) => expense.accountingId === a.accountingId
                                        );
                                        const indexB = updatedExpenseList.findIndex(
                                            (expense) => expense.accountingId === b.accountingId
                                        );

                                        if (indexA === -1 && indexB === -1) return 0;
                                        if (indexA === -1) return 1;
                                        if (indexB === -1) return -1;

                                        return indexA - indexB;
                                    });

                                    return sorted;
                                };

                                setTempAdditionalInfoList((prevList) => sortByExpenseIndex(prevList));
                                setRequestAdditionalInfoList((prevList) => sortByExpenseIndex(prevList));
                            }
                            setEditModeExpense(false);
                            setAddedExpense(true);
                            setLocalDisplayExpense(false);
                            setRequestReimbursementExpense((prevFormData) => ({
                                ...prevFormData,
                                id: null,
                                fileId: "",
                                fileExtension: "",
                                amount: 0,
                                vatAmount: '',
                                accountingId: "",
                                accountingName: "",
                                additionalInfo: null,
                                additionalFileExtension: ""
                            }));
                            $("#accountingId").val("");
                            return true;
                        }
                    }
                }
                return false;
            } catch (error) {
                //console.log({error})
                return false;
            }
        } else {
            CheckRequired();
            return false;
        }
    };

    useEffect( ()=>{
        if(requestAdditionalInfo.additionalInfo != null){
            const fieldsToUpdate = {
                    additionalInfo: requestAdditionalInfo.additionalInfo,
                    additionalFileName: requestAdditionalInfo.additionalFileName,
                    additionalFileExtension: requestAdditionalInfo.additionalFileExtension
                };
                //setTempAdditionalInfoList(prevList => 
                // setRequestAdditionalInfoList(prevList => 
                //     prevList.map(info => {
                //         if (info.accountingId === requestAdditionalInfo.accountingId) {
                //             return { 
                //                 ...info,
                //                 ...fieldsToUpdate 
                //             };
                //         }
                //         return info;
                //     })
                // );
        }
    }
    ,[requestAdditionalInfo])

    const ToggleParticipantsError = (selector, hasError) => {
        if (hasError) {
            $(selector).removeClass("d-none");
            return;
        }
        $(selector).addClass("d-none");
    };

    const ToParticipantsErrorKey = (fieldName = "") => {
        if (!fieldName) {
            return "";
        }
        return fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
    };

    // HANDLE CHANGE PARTICIPANTS (Refactorizado)
    const HandleChangeParticipants = (e, name, extraFieldName = null, id, index = null) => {

        setTempAdditionalInfoList(prevData => {
        //setRequestAdditionalInfoList(prevData => {
            return prevData.map(item => {

                // Every expense with the same required documentation shares the same list/attachment
                if (!IsInSameDocumentGroup(prevData, item, id)) {
                    return item;
                }

                let updatedItemData = {};

                switch (name) {
                    case "dynamic":
                        if (Array.isArray(e)) { 
                            if (extraFieldName) setFileType(extraFieldName);
                            setTimeout(() => {
                                HandleUploadFile(e, setFileResponse, "dynamic", id);
                            }, 500);

                            updatedItemData = {};
                            if (extraFieldName) {
                                const errorFieldName = ToParticipantsErrorKey(extraFieldName);
                                ToggleParticipantsError(`#error${errorFieldName}-${item.accountingId}`, false);
                            }

                        } else { 
                            const fieldValue = e?.target?.value ?? "";
                            updatedItemData.additionalInfo = { 
                                ...item.additionalInfo, 
                                [extraFieldName]: fieldValue
                            };
                            if (extraFieldName) {
                                const errorFieldName = ToParticipantsErrorKey(extraFieldName);
                                const hasFieldError = fieldValue === "" || fieldValue === null;
                                ToggleParticipantsError(`#error${errorFieldName}-${item.accountingId}`, hasFieldError);
                            }
                        }
                        break;

                    case "radio":
                        const value = e?.target?.value;
                         updatedItemData.selectedRadioOption = value; 
                        if (value === "option1") {
                            updatedItemData.additionalInfo = {
                                ...item.additionalInfo,
                                program: item.additionalInfo?.program || "", 
                                participantsFileId: null
                            };
                            updatedItemData.additionalFileName = "";
                            updatedItemData.additionalFileExtension = "";

                        } else {

                            updatedItemData.additionalInfo = {
                                ...item.additionalInfo,
                                program: null,
                                participantsFileId: item.additionalInfo?.participantsFileId || ""
                            };
                        }
                        ToggleParticipantsError(`#errorRadio-${item.accountingId}`, false);
                        break;

                }
                return { ...item, ...updatedItemData };
            });
        });

        setCheckUnsaved(true);
    };
        
    const HandleValidateParticipants = async () => {
        let exit = false;
        // One entry per required documentation group (the same one shown in the participants panel)
        const filteredList = UniqueByDocumentGroup(tempAdditionalInfoList);
        filteredList.forEach((item) => {
            if (item?.additionalInfo && Object.keys(item?.additionalInfo).length > 0 && item?.requiredDocumentation?.length > 0) {
                if (item?.requiredDocumentation?.includes("Deltagarlista")) {
                    $(`#errorRadio-${item.accountingId}`).addClass("d-none");
                    $(`#errorProgram-${item.accountingId}`).addClass("d-none");
                    $(`#errorParticipantsFileId-${item.accountingId}`).addClass("d-none");

                    if (item?.requiredDocumentation?.includes("Deltagarlista")) {
                        const selectedRadio = $(`#divRadioInputs-${item.accountingId} input[type="radio"]:checked`);
                        const selectedRadioValue = item.selectedRadioOption;
                        
                        const value = selectedRadio.length > 0 ? selectedRadio.val() : selectedRadioValue;
                        
                        if (value) {
                            if (value === "option1") {
                                if (!item.additionalInfo?.program) {
                                    exit = true;
                                    $(`#errorProgram-${item.accountingId}`).removeClass("d-none");
                                } else {
                                    $(`#errorProgram-${item.accountingId}`).addClass("d-none");
                                }
                            } else if (value === "option2") {
                                if (!item.additionalInfo?.participantsFileId) {
                                    exit = true;
                                    $(`#errorParticipantsFileId-${item.accountingId}`).removeClass("d-none");
                                } else {
                                    $(`#errorParticipantsFileId-${item.accountingId}`).addClass("d-none");
                                }
                            }
                        } else {
                            exit = true;
                            $(`#errorRadio-${item.accountingId}`).removeClass("d-none");
                        }
                    }
                } else {
                    Object.keys(item.additionalInfo).forEach((fieldKey) => {
                        const selector = `#error${ToParticipantsErrorKey(fieldKey)}-${item.accountingId}`;
                        const fieldValue = item?.additionalInfo?.[fieldKey];
                        const hasError = fieldValue === "" || fieldValue === null || fieldValue === undefined;
                        ToggleParticipantsError(selector, hasError);
                        if (hasError) {
                            exit = true;
                        }
                    });
                }
            }
        });

        if (exit === false) {
            try {
                const cleanParticipants = filteredList.map((item) => ({
                    program: item?.additionalInfo?.program,
                    participantsFileId: item?.additionalInfo?.participantsFileId,
                    programFileId: item?.additionalInfo?.programFileId
                }));

                // All entries of the same accounting must carry the validated values, otherwise an
                // empty entry (e.g. from a second expense) overwrites them when the expenses are merged on submit
                const normalizedList = tempAdditionalInfoList.map((expense) => {
                    const found = filteredList.find((item) => GetDocumentGroupKey(item) === GetDocumentGroupKey(expense));
                    if (!found) {
                        return expense;
                    }

                    return {
                        ...expense,
                        additionalInfo: found?.additionalInfo,
                        additionalFileName: found?.additionalFileName,
                        additionalFileExtension: found?.additionalFileExtension,
                        selectedRadioOption: found?.selectedRadioOption,
                    };
                });

                setTempAdditionalInfoList(normalizedList);
                setRequestReimbursementParticipants(cleanParticipants);
                setRequestAdditionalInfoList(normalizedList);
                setAccordionStatusParticipants(false);
                setAddedAttachments(true);

                if (editModeParticipants === true) {
                    setEditModeParticipants(false);
                }
            } catch (error) {
                console.log("Error en validación de participantes:", error);
                return true;
            }
        }
        
        return exit;
    };

    

    // HANDLE CANCEL EXPENSE
    const HandleCancelExpense = (expense) => {
        if (editModeExpense === true && expenseIndex !== null) {
            setRequestReimbursementExpenseList((prevFormData) => {
                return prevFormData.map((item, i) => {
                    if (i === expenseIndex) {
                        return expense;
                    } else {
                        return item;
                    }
                });
            });
            setExpenseIndex(null);
        } else {
            setRequestReimbursementExpenseList((prevFormData) => ([
                ...prevFormData,
                expense
            ]));
        }
        setExpenseIndex(null);
        setEditModeExpense(false);
        setLocalDisplayExpense(false);
        setRequestReimbursementExpense((prevFormData) => ({
            ...prevFormData,
            id: null,
            fileId: "",
            fileExtension: "",
            amount: 0,
            vatAmount: '',
            accountingId: "",
            accountingName: "",
            additionalInfo: null,
            additionalFileExtension: ""
        }));
        $("#accountingId").val("");
    }
    /********************************************* EXPENSE *******************************************/

    /********************************************* MODAL SEND ****************************************/
    // REDIRECT WHEN FINISH
    useEffect(() => {
        if (responseReimbursement && responseReimbursement.id !== "") {
            if (!isSend) {
                FlashMessage(t('validationMessage.reimbursementSavedSuccessfully'), 'flash-messageSuccess');
                setTimeout(() => {
                    CustomReload(backButtonUrl)
                }, 2000);
            } else {
                setDisplaySuccessModal(true);
                setDisplaySpinner(false);
            }
        }
    }, [responseReimbursement]);

    // SEND FORM
    const SubmitReimbursement = async () => {
        
        if (!isSend) {
            requestReimbursement.status = "Förslag";
        } else {
            requestReimbursement.status = "Skickat";
        }
        if (isSend && grossAmount <= 0) {
            setDisplaySendModal(false);
            setResponseConfirmFunds(null);
            $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", false);
            FlashMessage(t('validationMessage.totalAmountMustBeMoreThan0'), 'flash-messageError');        
            $("#forms").removeClass("d-none");
            return;
        }
        requestReimbursement.date = ChangeDateFormat("date", requestReimbursement.date);
        if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
            requestReimbursement.toDate = ChangeDateFormat("date", requestReimbursement.toDate);
        } else {
            requestReimbursement.toDate = null;
        }
        requestReimbursement.fixeds = null;
        requestReimbursement.mileage = null;
        requestReimbursement.expenses = null;
        if (!displayFixed && requestReimbursementFixedList.length > 0) {
            if (isFixed) {
                requestReimbursementFixed.hours = null;
                if (requestReimbursementFixed.id === "" || requestReimbursementFixed.id === undefined) {
                    requestReimbursementFixed.id = null;
                }
                if (requestReimbursementFixed.costBearerId === "") {
                    requestReimbursementFixed.costBearerId = requestReimbursement.costBearerId;
                }
                if (requestReimbursementFixed.date === "") {
                    requestReimbursementFixed.date = requestReimbursement.date;
                }
                if (requestReimbursementFixed.toDate === "") {
                    requestReimbursementFixed.toDate = requestReimbursement.toDate;
                }
                if (requestReimbursementFixed.purpose === "") {
                    requestReimbursementFixed.purpose = requestReimbursement.purpose;
                }
                if (!requestReimbursementFixed.orgId || requestReimbursementFixed.orgId === "") {
                    requestReimbursementFixed.orgId = requestReimbursement.orgId;
                }
                if (requestReimbursementFixed.salaryDate !== "") {
                    requestReimbursementFixed.salaryDate = ChangeDateFormat("date", requestReimbursementFixed.salaryDate);
                } else if (requestReimbursementFixed.salaryDate === "") {
                    requestReimbursementFixed.salaryDate = requestReimbursement.date;
                }
                requestReimbursement.fixeds = [
                    requestReimbursementFixed
                ];
            } else {
                requestReimbursementFixedList.map(item => {
                    if (item.id === "" || item.id === undefined) {
                        item.id = null;
                    }
                    if (!item.orgId || item.orgId === "") {
                        item.orgId = requestReimbursement.orgId;
                    }
                    if (item.costBearerId === "") {
                        item.costBearerId = requestReimbursement.costBearerId;
                    }
                    if (item.date === "") {
                        item.date = requestReimbursement.date;
                    }
                    if (item.toDate === "") {
                        item.toDate = requestReimbursement.toDate;
                    }
                    if (item.purpose === "") {
                        item.purpose = requestReimbursement.purpose;
                    }
                    if (item.salaryDate !== "") {
                        item.salaryDate = ChangeDateFormat("date", item.salaryDate);
                    }
                });
                requestReimbursement.fixeds = requestReimbursementFixedList;
            }
        }
        if (!displayMileage && requestReimbursementMileage.from && requestReimbursementMileage.from !== "") {
            if (requestReimbursementMileage.costBearerId === "") {
                requestReimbursementMileage.costBearerId = requestReimbursement.costBearerId;
            }
            if (requestReimbursementMileage.date === "") {
                requestReimbursementMileage.date = requestReimbursement.date;
            }
            if (requestReimbursementMileage.toDate === "") {
                requestReimbursementMileage.toDate = requestReimbursement.toDate;
            }
            if (requestReimbursementMileage.purpose === "") {
                requestReimbursementMileage.purpose = requestReimbursement.purpose;
            }
            requestReimbursement.mileage = requestReimbursementMileage;
        }
        if (addedExpense && requestReimbursementExpenseList.length > 0) {
            const expensesToSave = requestReimbursementExpenseList.map(item => ({...item}));
            
            expensesToSave.map(item => {
                if (item.costBearerId === "") {
                    item.costBearerId = requestReimbursement.costBearerId;
                }
                if (item.date === "") {
                    item.date = requestReimbursement.date;
                }
                if (item.toDate === "") {
                    item.toDate = requestReimbursement.toDate;
                }
                if (item.purpose === "") {
                    item.purpose = requestReimbursement.purpose;
                }
                if (item.additionalFileExtension === "") {
                    item.additionalFileExtension = null;
                }
                if (item.additionalFileName === "") {
                    item.additionalFileName = null;
                }
                if (item.dateReceive !== "") {
                    item.dateReceive = ChangeDateFormat("date", item.dateReceive);
                }
                if (item.vatAmount === "" || item.vatAmount === undefined) {
                    item.vatAmount = null;
                }
                else if (typeof item.vatAmount === 'string' && item.vatAmount !== null) {
                    const parsed = parseFloat(item.vatAmount);
                    item.vatAmount = isNaN(parsed) ? null : parsed;
                }
            });

            expensesToSave.forEach(expenseItem => {
                const hasExtraFields = infoResponse?.accountingsExtraFields?.some(
                    extra => extra.accountingId === expenseItem.accountingId && 
                            extra.extraFields && 
                            extra.extraFields.length > 0
                );
                
                if (!hasExtraFields) {
                    expenseItem.additionalInfo = null;
                    expenseItem.additionalFileExtension = null;
                    expenseItem.additionalFileName = null;
                }
            });

            requestAdditionalInfoList.forEach(infoItem => {
                expensesToSave.forEach(expenseItem => {
                    if (expenseItem.accountingId === infoItem.accountingId) {
                        const hasExtraFields = infoResponse?.accountingsExtraFields?.some(
                            extra => extra.accountingId === expenseItem.accountingId && 
                                    extra.extraFields && 
                                    extra.extraFields.length > 0
                        );
                        
                        if (hasExtraFields) {
                            expenseItem.additionalInfo = { ...expenseItem.additionalInfo, ...infoItem.additionalInfo };
                            expenseItem.additionalFileExtension = infoItem.additionalFileExtension;
                            expenseItem.additionalFileName = infoItem.additionalFileName;
                        }
                    }
                });
            });

            const cleanedList = expensesToSave.map(item => {
                const additionalInfo = item.additionalInfo || {};
                const cleanedAdditionalInfo = Object.fromEntries(
                    Object.entries(additionalInfo).filter(([key, value]) => value !== null && value !== "")
                );
                
                const hasAdditionalInfo = Object.keys(cleanedAdditionalInfo).length > 0;
                
                return {
                    ...item,
                    additionalInfo: hasAdditionalInfo ? cleanedAdditionalInfo : null,
                    additionalFileExtension: hasAdditionalInfo ? item.additionalFileExtension : null,
                    additionalFileName: hasAdditionalInfo ? item.additionalFileName : null
                };
            });          
            requestReimbursement.expenses = cleanedList;
        }

        //if (requestFileList && requestFileList.length > 0) {
            requestReimbursement.attachments.fileList = requestFileList;
        //}

        //if (requestCommentList && requestCommentList.length > 0) {
            requestReimbursement.attachments.commentList = requestCommentList;
        //}
        const apiCallOptions = {
            method: "post",
            url: "/reimbursement/v2",
            data: requestReimbursement,
        };
        try {
            if (!isSend) {
                await completeSchemaSave.validate(requestReimbursement, {abortEarly: false});
            } else {
                await completeSchema.validate(requestReimbursement, {abortEarly: false});
            }
            setDisplayFixed(false);
            setDisplayMileage(false);
            setDisplayExpense(false);
            $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", true);
            setDisplaySpinner(true);
            await ApiCall(apiCallOptions, setResponseReimbursement, setErrorMessage);
            setCheckUnsaved(false);
            setDisplaySendModal(false);
        } catch (error) {
            //console.log({error});
        }
    };
    const IVA_RATE = 0.25;
    function calculateVAT(requestReimbursementExpenseList) {
        if (!requestReimbursementExpenseList || requestReimbursementExpenseList.length === 0) {
            return 0;
        }

        const totalIVA = requestReimbursementExpenseList.reduce((acc, expense) => {
            const accountingName = expense?.accountingName?.trim();

            if (!accountingName) {
                return acc;
            }

            if (accountingName.includes("6072")) {
                const amount = Number(expense?.amount ?? 0);

                if (amount > 0) {
                    const iva = amount - (amount / (1 + IVA_RATE));
                    return acc + iva;
                }
            }
            else {
            const expenseVat = Number(expense?.vatAmount ?? 0);
            if (expenseVat > 0) {
                return acc + expenseVat;
            }
        }

            return acc;
        }, 0);

        return totalIVA;
    }

    const ConfirmFunds = async () => { 
        $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", true); 
        const totalVAT = calculateVAT(requestReimbursementExpenseList);
        let amount = 0;
        amount = grossAmount;
        if (totalVAT > 0) {
            amount -= totalVAT;
        }    
        const apiCallOptions = {
            method: "get",
            url: `/reimbursement/confirm-funds?orgId=${requestReimbursement.orgId}&amount=${amount}`,
        };
        try {
            await ApiCall(apiCallOptions, setResponseConfirmFunds, setErrorMessage);
        } catch (error) {
            //console.log({error});
        }
    };

    useEffect(() => {
        const checkResponse = () => {
            if (responseConfirmFunds) {
                setDisplaySendModal(true);
            }
        };
        checkResponse();
    }, [responseConfirmFunds]);

    useEffect(() => {
            if (errorMessage !== '') {        
                if (errorMessage === 'UserWithoutPnr') {
                    FlashMessage('Användaren har inte Pnr , därför är det inte möjligt att behandla denna begäran.', 'flash-messageError', 4500);
                    setTimeout(()=>{CustomReload();},4800);
                }
                else if (errorMessage.includes("{")) {
                    $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", false);
                    setResponseConfirmFunds(null);
                    setDisplayConfirmFundsModal(true);                    
                }               
                else{
                    FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
                    setTimeout(()=>{CustomReload();},4800); 
                }  
                     
            }
        }, [errorMessage]);

    const modalSendContent = (
        <div id="sendMessageDiv">
            {isSend === false ? t('validationMessage.saveReimbursement') : t('validationMessage.sendReimbursement')}
        </div>
    );

    const modalSuccessContent = (
        <div style={{ padding: "16px 8px" }}>
            {/* Icono checkmark */}
            <div style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "#D6EAE1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
            }}>
                <i className="bx bx-check" style={{ fontSize: 44, color: "#157553" }} />
            </div>

            <h4 className="rokkitt-font" style={{ fontWeight: 700, color: "#157553", marginBottom: 10 }}>
                {selectedOrgType === "Lokal grupp"
                    ? t('attest.attestProceeding')
                    : t('validationMessage.reimbursementSuccessfully')}
            </h4>
            <p style={{ fontSize: 14, color: "#6B7280", margin: 0 }}>
                {t('validationMessage.reimbursementWillBeProcessed')}
            </p>
        </div>
    );

    const modalSuccessFooter = (
        <Button
            className="btn-submit-kassan border-0 w-100 py-3"
            style={{ borderRadius: 10, fontSize: 16, fontWeight: 600 }}
            onClick={() => {
                setDisplaySuccessModal(false);
                CustomReload(backButtonUrl);
            }}
        >
            Stäng
        </Button>
    );

    const modalSendFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                 //const hasErrors = await HandleValidateParticipants();
                 //if(!hasErrors){
                    await SubmitReimbursement();
                 //}   
            }}>
                {isSend === false ? t('button.save') : t('button.send')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", false);
                setResponseConfirmFunds(null);
                setDisplaySendModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalConfirmFunds = (
        <>
            {errorMessage !== '' && <InsufficientFundsModal jsonString={errorMessage} />}
        </> 
    );

    const modalConfirmFundsFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                setDisplayConfirmFundsModal(false);
                 const hasErrors = await HandleValidateParticipants();
                 if(!hasErrors){                
                    await SubmitReimbursement() ;
                 }   
            }}>
                OK
            </Button>
            <Button className="box-red border-0" onClick={() => {
                $("#submitReimbursement, #saveReimbursement, #sendButton").prop("disabled", false);
                setErrorMessage('');
                setDisplayConfirmFundsModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );
    /********************************************* MODAL SEND ****************************************/

    /********************************************* MODAL DELETE FORMS ********************************/
    // DELETE FORMS
    const DeleteFixed = () => {
        let fixedAmount = 0;
        fixedAmount += requestReimbursementFixed.amount;
        if (requestReimbursementFixedList.length > 0) {
            requestReimbursementFixedList.map(item => {
                fixedAmount += item.amount;
            });
        }
        if (fixedAmount > 0) {
            setGrossAmount(grossAmount - fixedAmount);
        }

        const cleanBaseFixed = new RequestReimbursementFixed({
            id: null,
            orgId: requestReimbursement.orgId || selectedOrgId || "",
            date: requestReimbursement.date || "",
            toDate: requestReimbursement.toDate || null,
            purpose: requestReimbursement.purpose || "",
            costBearerId: requestReimbursement.costBearerId || selectedCostBearerId || "",
            salaryDate: requestReimbursement.date || "",
            type: "Hourly",
            hours: 0,
            amount: 0,
            status: ""
        });

        let nextFixedList = [];
        if (requestReimbursement.date && requestReimbursement.date !== "") {
            if (requestReimbursement.toDate && requestReimbursement.toDate !== "") {
                const dateFormated = new Date(ChangeDateFormat("date", requestReimbursement.date));
                const toDateFormated = new Date(ChangeDateFormat("date", requestReimbursement.toDate));
                const secondsDifference = toDateFormated.getTime() - dateFormated.getTime();
                const days = (secondsDifference / (1000 * 60 * 60 * 24)) + 1;

                if (days > 0) {
                    for (let i = 0; i < days; i++) {
                        const tempFixed = _.cloneDeep(cleanBaseFixed);
                        const salaryDate = new Date(dateFormated);
                        salaryDate.setDate(salaryDate.getDate() + i);
                        tempFixed.salaryDate = ChangeDateFormat("date", salaryDate);
                        nextFixedList.push(tempFixed);
                    }
                }
            } else {
                nextFixedList = [cleanBaseFixed];
            }
        }

        setDisplayFixed(true);
        setEditModeFixed(false);
        setIsFixed(false);
        setWasAddedFixed(false);
        setDeletedFixed(false);
        $("#date, #toDate, #checkInput").prop("disabled", false);
        $("#errorFixedAmount, #errorMovableAmount").addClass("d-none");
        setRequestReimbursementFixed(cleanBaseFixed);
        setRequestReimbursementFixedList(nextFixedList);
    };

    // DELETE MILEAGE
    const DeleteMileage = () => {
        setGrossAmount(grossAmount - requestReimbursementMileage.totalAmount);
        setRequestReimbursementMileage((prevFormData) => ({
            ...prevFormData,
            from: "",
            to: "",
            km: 0,
            amount: 0,
            passengers: null,
            totalAmount: 0,
            status: "",
        }));
        setEditModeMileage(false);
        setDisplayMileage(true);
    };

    // DELETE EXPENSE
    const DeleteExpense = (index = null) => {
        if (index !== null) {          
            if (requestReimbursementExpenseList[index]) {
                const expenseToDelete = requestReimbursementExpenseList[index];
                const expenseAccountingId = expenseToDelete?.accountingId;
                const expenseTemporalId = expenseToDelete?.temporalId;

                // Remove only the entry of the deleted expense: before, every entry of the accounting was removed,
                // so the remaining expenses of that accounting were sent without participant list (no validation)
                const accountingStillUsed = requestReimbursementExpenseList.some(
                    (expense, i) => i !== index && expense.accountingId === expenseAccountingId
                );
                const RemoveInfoEntryOfExpense = (prevList) => {
                    if (!expenseAccountingId && !expenseTemporalId) {
                        return prevList.filter((item, idx) => idx !== index);
                    }
                    if (!accountingStillUsed) {
                        return prevList.filter(item => item.accountingId !== expenseAccountingId);
                    }
                    const indexToRemove = _.findLastIndex(prevList, item => item.accountingId === expenseAccountingId);
                    return prevList.filter((item, idx) => idx !== indexToRemove);
                };

                setTempAdditionalInfoList(RemoveInfoEntryOfExpense);
                setRequestAdditionalInfoList(RemoveInfoEntryOfExpense);
            }

            let expenseAmount = 0;
            if (requestReimbursementExpenseList.length > 0) {
                requestReimbursementExpenseList.map(item => {
                    expenseAmount += item.amount;
                });
            }
            if (expenseAmount > 0) {
                setGrossAmount(grossAmount - expenseAmount);
            }
            const expenseList = requestReimbursementExpenseList.filter((item, i) => i !== index);
            setRequestReimbursementExpenseList((prevFormData) => {
                return prevFormData.filter((item, i) => i !== index);
            });
            setExpenseIndex(null);
            setEditModeExpense(false);
            setLocalDisplayExpense(false);
            if (expenseList.length === 0) {
                setAddedExpense(false);
            }
            setRequestAdditionalInfo(new RequestAdditionalInfo());
            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                fileId: "",
                fileExtension: "",
                amount: 0,
                vatAmount: '',
                accountingId: "",
                additionalInfo: null,
                additionalFileExtension: ""
            }));
            $("#accountingId").val("");
        }
    };

    // MODAL DELETE
    const HandleModalDelete = () => {
        switch (reimbursementToDelete) {
            case "Fixed":
                DeleteFixed();
                break;
            case "Mileage":
                DeleteMileage();
                break;
            case "Expense":
                DeleteExpense(expenseIndex);
                break;
            default:
                break;
        }
        setDisplayDeleteModal(false);
    };

    const modalDeleteContent = (
        <div>
            {reimbursementToDelete === "Fixed" ? t('validationMessage.deleteFixed') : reimbursementToDelete === "Mileage" ? t('validationMessage.deleteMileage') : t('validationMessage.deleteExpense')}
        </div>
    );
    const modalDeleteFooter = (
        <>
            <Button className="box-green border-0" onClick={HandleModalDelete}>
                {t('button.delete')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayDeleteModal(false)}>{t('button.cancel')}</Button>
        </>
    );
    /********************************************* MODAL DELETE FORMS ********************************/

    /********************************************* MODAL DELETE ****************************************/
    // HANDLE MODAL DELETE
    const HandleDeleteReimbursement = async () => {
        if (id !== "") {
            const apiCallOptions = {
                method: "delete",
                url: `/reimbursement/`,
                data: {id: id}
            };
            try {
                await ApiCall(apiCallOptions, setResponseDelete);
                setDisplayDeleteReimbursementModal(false);
            } catch (error) {
                //console.log({error});
            }
        }
    }

    // REDIRECT WHEN FINISH
    useEffect(() => {
        if (responseDelete && id !== "") {
            navigate(backButtonUrl);
        }
    }, [responseDelete, id, navigate, backButtonUrl]);

    const modalContentDeleteReimbursementModal = (
        <div>
            {`${t('validationMessage.modalVar')}?`}
        </div>
    );
    const modalFooterDeleteReimbursementModal = (
        <>
            <Button className="box-green border-0" onClick={HandleDeleteReimbursement}>
                {t('button.delete')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayDeleteReimbursementModal(false)}>{t('button.cancel')}</Button>
        </>
    );
    /********************************************* MODAL DELETE ****************************************/

    /********************************************* MODAL ADITTIONAL FILES ****************************************/

    const handleDeleteOtherFile = (idToDelete, type) => {
        if (type === "file") {
            setTempFileList(prevList => prevList.filter(file => file.id !== idToDelete));
            setRequestFileList(prevList => prevList.filter(file => file.id !== idToDelete));
        } else if (type === "comment") {
            setTempCommentList(prevList => prevList.filter(comment => comment.id !== idToDelete));
            setRequestCommentList(prevList => prevList.filter(comment => comment.id !== idToDelete));
        }
    };

    const handleIndividualFileUpload = async (file, frontendId) => {
        const validTypes = ["image/png", "image/jpg", "image/gif", "image/jpeg", "application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", "text/plain"];
        if (!validTypes.includes(file.type)) {
            return; 
        }

        if (file.size > MAX_FILE_SIZE_BYTES) {
            FlashMessage(t('validationMessage.maxSizeFile'), 'flash-messageWarning');
            return;
        }
        
        const formData = new FormData();
        formData.append('file', file);
        setUploadContext({
            frontendId: frontendId,
            originalName: file.name,
            originalType: file.type
        });

        try {
            const apiCallOptions = {
                method: "post",
                url: "/file",
                data: formData,
                dataTypes: "file"
            };
            
            await ApiCall(apiCallOptions, setAdditionalFileResponse);

            
        } catch (error) {
            console.error("Error al subir el archivo:", error);
            setUploadContext(null); 
        }
    };

    useEffect(() => {
        if (additionalFileResponse && additionalFileResponse.id && uploadContext) {
            
            const uploadedFile = {
                id: uploadContext.frontendId,
                fileId: additionalFileResponse.id,
                fileName: uploadContext.originalName,
                fileExtension: uploadContext.originalType
            };
            //setRequestFileList(prevList => {
            setTempFileList(prevList => {
                const fileExists = prevList.some(item => item.id === uploadContext.frontendId);
                if (fileExists) {
                    return prevList.map(item => item.id === uploadContext.frontendId ? uploadedFile : item);
                } else {
                    return [...prevList, uploadedFile];
                }
            });

            setAdditionalFileResponse(null);
            setUploadContext(null);
        }
    }, [additionalFileResponse, uploadContext]);


    const HandleChangeAdditionalFiles = (e, type, attribute = null, id) => {

        if (type === "otherComment") {
            const { value } = e.target;
            if (value === '') {
            setRequestCommentList(prevList => 
                prevList.filter(comment => comment.id !== id)
            );
        } else {
            //setRequestCommentList(prevList => {
            setTempCommentList(prevList => {
                const commentExists = prevList.some(comment => comment.id === id);
                if (commentExists) {
                    return prevList.map(comment =>
                        comment.id === id
                            ? { ...comment, comment: value }
                            : comment
                    );
                } else {
                    return [...prevList, { id: id, comment: value, requestId: 0 }];
                }
            });
        }
        }

        if (type === "otherFile") {
            const file = e[0];
            setTimeout(() => {
                handleIndividualFileUpload(file, id);
            }, 500);
        }
    };

    const HandleValidateFields = () => {
        let hasErrors = false;

        // otherComments.forEach(commentUI => {
        //     const commentData = requestCommentList.find(c => c.id === commentUI.id);

        //     if (!commentData || !commentData.comment || commentData.comment.trim() === '') {
        //         hasErrors = true;
        //         $(`#error-additionalInfo-${commentUI.id}`).removeClass('d-none');
        //     } else {
        //         $(`#error-additionalInfo-${commentUI.id}`).addClass('d-none');
        //     }
        // });

        // otherFiles.forEach(fileUI => {
        //     const fileData = requestFileList.find(f => f.id === fileUI.id);
        //     if (!fileData || !fileData.fileId) {
        //         hasErrors = true;
        //         $(`#error-otherFile-${fileUI.id}`).removeClass('d-none');
        //     } else {
        //         $(`#error-otherFile-${fileUI.id}`).addClass('d-none');
        //     }
        // });
        setAddedAttachments(true);
        setAddedAttachmentsExtra(true);
        // NUEVO AGREGADO INICIO
        if (!hasErrors) {
            const validComments = tempCommentList.filter(c => c.comment && c.comment.trim() !== '');
            setRequestCommentList(validComments);  
            setRequestFileList(tempFileList);
            setAddedAttachments(true);
            setAddedAttachmentsExtra(true);
            
            // Opcional: cierra el acordeón si lo deseas
            //setAccordionStatus(false); 
        }
        // Fin de NUEVO AGREGADO
        return hasErrors;
    };

    // useEffect(() => {
    //     console.log("Lista de comentarios:", requestCommentList);
    // }, [requestCommentList]);

    // useEffect(() => {
    //     console.log("Lista de files:", requestFileList);
    // }, [requestFileList]);

    /********************************************* MODAL ADITTIONAL FILES ****************************************/
    // ID NULL IF IS NOT A DRAFT
    useEffect(() => {
        if (!draftResponse) {
            setRequestReimbursement((prevFormData) => ({
                ...prevFormData,
                id: null
            }));
            setRequestReimbursementFixed((prevFormData) => ({
                ...prevFormData,
                id: null
            }));
            if (requestReimbursementFixedList.length > 0) {
                requestReimbursementFixedList.map(item => {
                    item.id = null;
                });
                setRequestReimbursementFixedList(requestReimbursementFixedList);
            }
            setRequestReimbursementMileage((prevFormData) => ({
                ...prevFormData,
                id: null,
                passengers: null,
            }));
            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                id: null,
                
            }));
            if (requestReimbursementExpenseList.length > 0) {
                requestReimbursementExpenseList.map(item => {
                    item.id = null;
                });
                setRequestReimbursementExpenseList(requestReimbursementExpenseList);
            }
        }
    }, [draftResponse]);

    useEffect(() => {
        if(requestReimbursementExpenseList.length > 0) {
            const arrayExtraField = [];
            if (infoResponse?.accountingsExtraFields?.length) {
                
                requestReimbursementExpenseList.map((item, index) => {
                    
                    if(item.accountingId !== null && item.additionalInfo !== null) {
                        const foundExtra = infoResponse.accountingsExtraFields.find(extra => extra.accountingId === item.accountingId);                        
                        arrayExtraField.push(foundExtra);
                    }
                });
                // const uniqueData = Array.from(
                //     arrayExtraField.reduce((map, item) => {
                //         if (!map.has(item?.accountingId)) {
                //             map.set(item.accountingId, item);
                //         }
                //         return map;
                //     }, new Map()).values()
                // );
                const uniqueData = Array.from(
                arrayExtraField.filter(item => item).reduce((map, item) => {
                    if (!map.has(item.accountingId)) {
                        map.set(item.accountingId, item);
                    }
                    return map;
                    }, new Map()).values()
                );
                setExtraFields(uniqueData);
            }

        }
    }, [requestReimbursementExpenseList, infoResponse]);

    // SELECTED ORG
    useEffect(() => {
        if (selectedOrgId !== "") {
            let costBearerId = requestReimbursement.costBearerId;
            if (infoResponse && infoResponse.orgsByUser && Array.isArray(infoResponse.orgsByUser) && infoResponse.orgsByUser.length > 0 && infoResponse.costBearersByOrgType && Array.isArray(infoResponse.costBearersByOrgType) && infoResponse.costBearersByOrgType.length > 0 && infoResponse.costBearers && Array.isArray(infoResponse.costBearers) && infoResponse.costBearers.length > 0) {
                // COST BEARERS
                let orgType = "";
                infoResponse.orgsByUser.map(item => {
                    if (item.id === selectedOrgId) {
                        orgType = item.type;
                        setSelectedOrgName(item.name);
                        setSelectedOrgType(item.type);
                    }
                });
                const costBearersByOrgType = infoResponse.costBearersByOrgType.find(item => item.type === orgType);
                if (costBearersByOrgType) {
                    const costBearerJsonArray = infoResponse.costBearers.filter(cb => costBearersByOrgType.costBearerNames.includes(cb.name)).map(cb => ({
                        id: cb.id,
                        name: cb.name
                    }));

                    if (costBearerJsonArray.length > 0 && !costBearerJsonArray.find(item => item.id === selectedCostBearerId)) {
                        setSelectedCostBearerId("");
                        setSelectedCostBearerName("");
                        costBearerId = "";
                    }

                    setCostBearers({
                        costBearer: costBearerJsonArray
                    });
                }
            }

            setRequestReimbursement((prevFormData) => ({
                ...prevFormData,
                orgId: selectedOrgId,
                costBearerId: costBearerId,
            }));
            setRequestReimbursementFixed((prevFormData) => ({
                ...prevFormData,
                orgId: selectedOrgId,
                costBearerId: costBearerId,
            }));
            if (requestReimbursementFixedList.length > 0) {
                requestReimbursementFixedList.map(item => {
                    item.orgId = selectedOrgId;
                    item.costBearerId = costBearerId;
                });
                setRequestReimbursementFixedList(requestReimbursementFixedList);
            }
            setRequestReimbursementMileage((prevFormData) => ({
                ...prevFormData,
                orgId: selectedOrgId,
                costBearerId: costBearerId,
            }));
            setRequestReimbursementExpense((prevFormData) => ({
                ...prevFormData,
                orgId: selectedOrgId,
                costBearerId: costBearerId,
            }));
            if (requestReimbursementExpenseList.length > 0) {
                requestReimbursementExpenseList.map(item => {
                    item.orgId = selectedOrgId;
                    item.costBearerId = costBearerId;
                });
                setRequestReimbursementExpenseList(requestReimbursementExpenseList);
            }
        }
    }, [selectedOrgId]);

    // SELECTED COST BEARER
    useEffect(() => {
        if (selectedCostBearerId !== "" && infoResponse && infoResponse.costBearers && Array.isArray(infoResponse.costBearers) && infoResponse.costBearers.length > 0) {
            infoResponse.costBearers.map(item => {
                if (item.id === selectedCostBearerId) {
                    setSelectedCostBearerName(item.showLabel ? item.showLabel : item.name);
                }
            });
        }
    }, [selectedCostBearerId]);

    // CALCULATE GROSS AMOUNT
    useEffect(() => {
        let tempAmount = 0;
        // SUM FIXED AMOUNT
        if (isFixed) {
            tempAmount += requestReimbursementFixed.amount;
        } else {
            if (requestReimbursementFixedList.length > 0) {
                requestReimbursementFixedList.map(item => {
                    tempAmount += item.amount;
                });
            }
        }
        // SUM MILEAGE AMOUNT
        tempAmount += Math.round((requestReimbursementMileage.totalAmount || 0) * 100) / 100;
        // SUM EXPENSES AMOUNT
        if (requestReimbursementExpenseList.length > 0) {
            requestReimbursementExpenseList.map(item => {
                tempAmount += item.amount;
            });
            // ORDER EXPENSES BY DATE RECEIVE
            setRequestReimbursementExpenseList((prevFormData) => {
                return prevFormData.sort((a, b) => {
                    return new Date(a.dateReceive) - new Date(b.dateReceive);
                });
            });
        }

        setGrossAmount(tempAmount);
    }, [displayFixed, displayMileage, addedExpense, requestReimbursementExpenseList]);

    // CHECK IF HAVE SOME CHANGES TO CHANGE MODAL MESSAGE
    const checkIfHaveChanges = (typeSend = null) => {
        // FIXED
        const hours = document.getElementsByClassName("hourDiv");
        const fixedAmount = $("#fixedAmount").val();
        // MILEAGE
        const origin = $("#origin").val();
        const destination = $("#destination").val();
        const km = $("#km").val();
        const number = $("#number").val();
        const distance = $("#distance").val();
        // EXPENSE
        const accounting = $("#accounting").val();
        const expenseAmount = $("#expenseAmount").val();
        if ((fixedAmount && fixedAmount !== "") || (origin && origin !== "") || (destination && destination !== "") || (km && km !== "") || (number && number !== "") || (distance && distance !== "") || (accounting && accounting !== "") || (expenseAmount && expenseAmount !== "")) {
            setTimeout(() => {
                $("#sendMessageDiv").html(typeSend === null ? t('validationMessage.sendReimbursementNotSaved') : t('validationMessage.sendReimbursementNotSavedSave'));
            }, 80);
        }
        if (hours) {
            const hourArray = Array.from(hours);
            hourArray.map(input => {
                if ($(input).find("input").val() !== "") {
                    setTimeout(() => {
                        $("#sendMessageDiv").html(typeSend === null ? t('validationMessage.sendReimbursementNotSaved') : t('validationMessage.sendReimbursementNotSavedSave'));
                    }, 80);
                }
            });
        }
    }

    const messageCostBearer = InputMessage(infoResponse && infoResponse.costBearers ? infoResponse?.costBearers : null, requestReimbursement.costBearerId);

    return (
        <>
            {permissionCreate && !isMobile && (
                <Col lg={12} className="px-0">
                    <CustomButton text={t('button.back')} icon={'bx bx-chevron-left'} buttonSize={'small'} customClasses={'mb-3 ms-3 backButton'}
                        onClick={() => navigate(backButtonUrl)}
                    />
                </Col>
            )}

            {infoResponse ? (
                <>
                    {infoResponse.userBankAccount && (infoResponse.userBankAccount.clearingNumber === undefined || infoResponse.userBankAccount.accountNumber === undefined) ? (
                        <Col lg={10} className="box-red mt-2 p-1 mx-auto">
                            {t('validationMessage.needAccount')} <Link className='underline' to={USER_PATHS.SETTINGS}>{t('validationMessage.goAddAccount')}</Link>
                        </Col>
                    ) : (
                        <>
                            {checkUnsaved === true && <CustomUnsavedModal backButtonUrl={backButtonUrl} />}
                            <CustomModal isOpen={displayDeleteReimbursementModal} toggle={() => setDisplayDeleteReimbursementModal(!displayDeleteReimbursementModal)} body={modalContentDeleteReimbursementModal} footer={modalFooterDeleteReimbursementModal} />
                            <CustomModal isOpen={displayDeleteModal} toggle={() => setDisplayDeleteModal(!displayDeleteModal)} body={modalDeleteContent} footer={modalDeleteFooter} />
                            <CustomModal isOpen={displaySendModal} toggle={() => setDisplaySendModal(!displaySendModal)} body={modalSendContent} footer={modalSendFooter} />
                            <CustomModal isOpen={displayConfirmFundsModal} toggle={() => setDisplayConfirmFundsModal(!displayConfirmFundsModal)} body={modalConfirmFunds} footer={modalConfirmFundsFooter} />
                            <CustomModal isOpen={displaySuccessModal} toggle={() => {}} body={modalSuccessContent} footer={modalSuccessFooter} />

                                <>
                                    <Col lg={7} id="formReimbursement" className="mx-0 px-0 pe-lg-2">
                                        {/* <Card className="card-backend p-4"> */}
                                            <Row>
                                                {!isMobile && (
                                                <Col xs='auto'>
                                                    <h2 className='rokkitt-font'>{t('reimbursement.reportProcessing')}</h2>
                                                </Col>
                                                )}
                                                <InfoPageMessage message={t('infoBox.reportProceeding')}/>
                                            </Row>
                                            <div className="custom-accordion-card">
                                                <button
                                                type="button"
                                                className="custom-accordion-header"
                                                onClick={() => setOpenReimbursementAccordion(prev => !prev)}
                                                >
                                                <span className="custom-accordion-title">
                                                    {t("reimbursement.generalInformation")}
                                                </span>

                                                <span className={`custom-accordion-icon ${openReimbursementAccordion ? "open" : ""}`}>
                                                    <i className='bx bx-chevron-down' ></i>
                                                </span>
                                                </button>

                                                <Collapse isOpen={openReimbursementAccordion}>
                                                    <div className="custom-accordion-body">
                                                        <Row>
                                                            <Col lg={6} onClick={() => $('.react-datepicker__tab-loop').removeClass('d-none')}>
                                                                <label className="d-block form-label rpv2-accordion-date-label">
                                                                    {requestReimbursement.toDate !== null ? t('modelLabel.fromDateReimbursement') : t('modelLabel.dateReimbursement')}:
                                                                </label>
                                                                <div className="position-relative">
                                                                <CustomInput
                                                                    model={RequestReimbursementV2}
                                                                    attribute="date"
                                                                    data={requestReimbursement.date}
                                                                    customChange={(e) => HandleChangeCommon(e, 'date')}
                                                                />
                                                                <div
                                                                    id="ErrorFormDate"
                                                                    className="error tooltip-custom show-custom d-none"
                                                                    style={{ color: '#f56e6e' }}
                                                                >
                                                                    {t('validationMessage.dateMustBeLessThanToDate')}
                                                                </div>
                                                                </div>

                                                                {requestReimbursement.toDate !== null && (
                                                                <CustomInput
                                                                    model={RequestReimbursementV2}
                                                                    attribute="toDate"
                                                                    data={requestReimbursement.toDate}
                                                                    minDate={requestReimbursement.date}
                                                                    customChange={(e) => HandleChangeCommon(e, 'toDate')}
                                                                />
                                                                )}

                                                                <div className="mb-3" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <label>{t('modelLabel.multipleDayEvent')}: </label>
                                                                <input
                                                                    style={{ marginTop: '4px' }}
                                                                    id="checkInput"
                                                                    checked={requestReimbursement.toDate !== null}
                                                                    type="checkbox"
                                                                    onChange={(e) => HandleChangeCommon(e, 'check')}
                                                                />
                                                                </div>
                                                            </Col>

                                                            <Col lg={6}>
                                                                <CustomInput
                                                                model={RequestReimbursementV2}
                                                                attribute="orgId"
                                                                data={selectedOrgId}
                                                                customChange={(e) => HandleChangeCommon(e, 'orgId')}
                                                                customOptions={orgs}
                                                                />
                                                            </Col>

                                                            <Col lg={6}>
                                                                <CustomInput
                                                                model={RequestReimbursementV2}
                                                                attribute="purpose"
                                                                data={requestReimbursement.purpose}
                                                                customChange={(e) => HandleChangeCommon(e, 'purpose')}
                                                                />
                                                            </Col>

                                                            <Col lg={6}>
                                                                {costBearers?.costBearer && selectedOrgId !== "" && (
                                                                <>
                                                                    <CustomInput
                                                                    model={RequestReimbursementV2}
                                                                    attribute="costBearerId"
                                                                    data={selectedCostBearerId}
                                                                    customChange={(e) => HandleChangeCommon(e, 'costBearerId')}
                                                                    customOptions={costBearers}
                                                                    />
                                                                    {messageCostBearer}
                                                                </>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Collapse>
                                            </div>
                                            <div className="createReimbursement-divider" />
                                            <div id="forms">
                                                {displayFixed && <ReimbursementFixed data={requestReimbursementFixedList} dataFixed={requestReimbursementFixed} onChange={HandleChangeFixed} onValidate={HandleValidateFixed} onCancel={HandleCancelFixed} editMode={editModeFixed} isFixed={isFixed} minFixedAmount={infoResponse?.hourlySalary?.value || 284} />}
                                                {displayMileage && <ReimbursementMileage data={requestReimbursementMileage} onChange={HandleChangeMileage} onValidate={HandleValidateMileage} onCancel={HandleCancelMileage} editMode={editModeMileage} />}
                                                {displayExpense && <ReimbursementExpense data={requestReimbursementExpense} onChange={HandleChangeExpense} onValidate={HandleValidateExpense} onCancel={HandleCancelExpense} editMode={editModeExpense} accountingJson={accountings} requestName={requestName} extraField={extraField} setIsDeletedFile={setIsDeletedFile} setIsDeletedExtraFile={setIsDeletedExtraFile} localDisplay={localDisplayExpense} setLocalDisplay={setLocalDisplayExpense} savedExpenses={requestReimbursementExpenseList} />}
                                                <ReimbursementParticipants otherComments={tempCommentList} setOtherComments={setTempCommentList} otherFiles={tempFileList} setOtherFiles={setTempFileList} data={tempAdditionalInfoList} onChange={HandleChangeParticipants} onValidate={HandleValidateParticipants} onCancel={HandleCancelExpense} editMode={editModeExpense} accountingJson={accountings} requestName={requestName} extraField={extraFields} setIsDeletedFile={setIsDeletedFile} setIsDeletedExtraFile={setIsDeletedExtraFile} localDisplay={localDisplayParticipants} setLocalDisplay={setLocalDisplayParticipants} savedExpenses={tempAdditionalInfoList} accordionStatus={accordionStatusParticipants} setAccordionStatus={setAccordionStatusParticipants} onChangeAditionalFields={HandleChangeAdditionalFiles} requestFileList={tempFileList} requestCommentList={requestCommentList} onDeleteOtherFile={handleDeleteOtherFile} onValidateFields={HandleValidateFields} />
                                            </div>
                                        {/* </Card> */}
                                    </Col>

                                    {/* Columna derecha — vista previa (igual que antes) */}
                                    <Col lg={5} id="viewReimbursement" className="mx-0 px-0 ps-lg-2">
                                        {draftResponse && draftResponse.denied && (
                                            <Card className="card-backend p-4 mb-3">
                                                <Row>
                                                    <Col lg={12} className="text-center">
                                                        <h2 className="text-red rokkitt-font">{t('reimbursement.deniedMessageCreate')}</h2>
                                                    </Col>
                                                    <Col lg={12} className="mb-3">
                                                        <Card className="bg-card-grey p-3">
                                                            <h5 className='rokkitt-font'>{t('attest.deniedBy')}</h5>
                                                            {draftResponse.denied.approvedDeniedByName}
                                                            <h5 className='rokkitt-font mt-4'>{t('modelLabel.reason')}</h5>
                                                            {draftResponse.denied.reason}
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        )}
                                        <Card className="custom-backend-card mb-5">
                                            <Row>
                                                <Col lg={12} className="text-start">
                                                    <h2 className='rokkitt-font'>{t('modelLabel.added')}</h2>
                                                    {/* <h5 className="rokkitt-font">{t('reimbursement.reportProcessings')}</h5> */}
                                                </Col>
                                                {/* <Col lg={12}>
                                                    {(requestReimbursement?.date !== '' || requestReimbursement?.costBearerId !== '' || requestReimbursement?.purpose !== '' || requestReimbursement?.orgId !== '') && (
                                                        <CustomReimbursementView data={requestReimbursement} costSelected={selectedCostBearerName} orgSelected={selectedOrgName} />
                                                    )}
                                                </Col> */}
                                                <Col lg={12}>
                                                    {((requestReimbursementFixedList.length > 0 && requestReimbursementFixedList.some(item => item.amount > 0) && !displayFixed && !editModeFixed) || (!displayFixed && !editModeFixed && isFixed)) && (
                                                        <>
                                                            {/* <h5 className='rokkitt-font mt-2'>{t('reimbursement.salary')}</h5> */}
                                                            <CustomReimbursementFixedView data={requestReimbursementFixedList} editMode={editModeFixed} dataFixed={requestReimbursementFixed} isFixed={isFixed}
                                                                onClickDelete={() => { setDisplayDeleteModal(true); setReimbursementToDelete('Fixed'); }}
                                                                onClickEdit={(item) => {
                                                                    $("#date, #toDate, #checkInput").prop("disabled", false);
                                                                    setDisplayFixed(true);
                                                                    setWasAddedFixed(item === null);
                                                                    setEditModeFixed(true);
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </Col>
                                                <Col lg={12}>
                                                    {!displayMileage && !editModeMileage && requestReimbursementMileage.from && requestReimbursementMileage.from !== "" && (
                                                        <>
                                                            {/* <h5 className='rokkitt-font mt-2'>{t('reimbursement.mileage')}</h5> */}
                                                            <CustomReimbursementMileageView data={requestReimbursementMileage} editMode={editModeMileage}
                                                                onClickDelete={() => { setDisplayDeleteModal(true); setReimbursementToDelete('Mileage'); }}
                                                                onClickEdit={() => { setDisplayMileage(true); setEditModeMileage(true); }}
                                                            />
                                                        </>
                                                    )}
                                                </Col>
                                                <Col lg={12}>
                                                    {requestReimbursementExpenseList.length > 0 && addedExpense && !editModeExpense && (
                                                        <>
                                                            {/* <h5 className='rokkitt-font mt-2'>{t('reimbursement.expenseTitle')}</h5> */}
                                                            <CustomReimbursementExpenseView data={requestReimbursementExpenseList} accountingResponse={infoResponse.accountings} editMode={editModeExpense}
                                                                onClickDelete={(item, index) => { setDisplayDeleteModal(true); setReimbursementToDelete('Expense'); setExpenseIndex(index); }}
                                                                onClickEdit={(item, index) => {
                                                                    if (infoResponse.accountingsIva?.length) {
                                                                        infoResponse.accountingsIva.forEach(item2 => {
                                                                            if (item2.accountingId === item.accountingId) item.vatAmount = null;
                                                                        });
                                                                    }
                                                                    setExpenseIndex(null);
                                                                    setEditModeExpense(false);
                                                                    HandleChangeExpense({ target: { value: item.accountingId } }, 'accountingId');
                                                                    setRequestReimbursementExpense(item);
                                                                    const existingAdditionalInfo = tempAdditionalInfoList.find(info => info.accountingId === item.accountingId);
                                                                    if (existingAdditionalInfo) {
                                                                        setRequestAdditionalInfo({
                                                                            accountingId: existingAdditionalInfo.accountingId,
                                                                            accountingName: existingAdditionalInfo.accountingName,
                                                                            additionalInfo: existingAdditionalInfo.additionalInfo || {},
                                                                            additionalFileName: existingAdditionalInfo.additionalFileName || '',
                                                                            additionalFileExtension: existingAdditionalInfo.additionalFileExtension || '',
                                                                            requiredDocumentation: existingAdditionalInfo.requiredDocumentation || [],
                                                                            selectedRadioOption: existingAdditionalInfo.selectedRadioOption || null,
                                                                        });
                                                                    }
                                                                    setExpenseIndex(index);
                                                                    setEditModeExpense(true);
                                                                }}
                                                                onClickRequired={() => {
                                                                    setAccordionStatusParticipants(true);
                                                                    // scroll suave hasta el panel
                                                                    setTimeout(() => {
                                                                        document.getElementById('forms')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                                    }, 100);
                                                                }}
                                                                additionalInfoList={requestAdditionalInfoList}
                                                            />
                                                        </>
                                                    )}
                                                    {addedAttachments && !editModeExpense && (
                                                        <>
                                                            {(requestFileList.length > 0 || requestAdditionalInfoList.length > 0 || requestCommentList.length > 0) && (
                                                                <h5 className="rokkitt-font mt-2">{t('reimbursement.participantsAndPrograms')}</h5>
                                                            )}
                                                            {requestAdditionalInfoList.length > 0 && (
                                                                <CustomReimbursementParticipantsView data={requestAdditionalInfoList} editMode={editModeExpense} isManual={true}
                                                                    onClickDelete={(item, index) => { setDisplayDeleteModal(true); setReimbursementToDelete('Expense'); setExpenseIndex(index); }}
                                                                    onClickEdit={(item, index) => { HandleChangeExpense({ target: { value: item.accountingId } }, 'accountingId'); setRequestReimbursementExpense(item); setExpenseIndex(index); setEditModeExpense(true); }}
                                                                />
                                                            )}
                                                            {/* {requestFileList.length > 0 && addedAttachmentsExtra && (
                                                                <CustomReimbursementAttachmentView dataFile={requestFileList} editMode={editModeExpense} onClickDelete={() => setDisplayDeleteModal(true)} onClickEdit={() => {}} />
                                                            )}
                                                            {requestCommentList.length > 0 && addedAttachmentsExtra && (
                                                                <CustomReimbursementCommentView dataComment={requestCommentList} editMode={editModeExpense} onClickDelete={() => setDisplayDeleteModal(true)} onClickEdit={() => {}} />
                                                            )} */}
                                                            {(requestFileList.length > 0 || requestCommentList.length > 0) && addedAttachmentsExtra && (
                                                                <CustomReimbursementAttachmentCommentView
                                                                    dataFile={requestFileList}
                                                                    dataComment={requestCommentList}
                                                                    editMode={editModeExpense}
                                                                    onClickDelete={() => setDisplayDeleteModal(true)}
                                                                    onClickEdit={() => {}}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </Col>

                                                <Col lg={12}>

                                                    {/* Divider */}
                                                    <div className="rpv2-divider" />

                                                    <Row className="text-start pt-4">
                                                        {grossAmount > 0 && ((requestReimbursementFixedList.length > 0 && !displayFixed) || !displayMileage || (addedExpense && requestReimbursementExpenseList.length > 0)) && !editModeFixed && !editModeMileage && !editModeExpense && (
                                                            <Col lg={12} className="pb-4 rokkitt-font fs-5">
                                                                <span className="fw-bold fs-5">{t('reportProceeding.calculations.total')}: </span>
                                                                <span className="fs-5">{ToCustomDecimal(grossAmount)} kr</span>
                                                            </Col>
                                                        )}
                                                        <Col lg={12} className="text-center pb-3">
                                                            {displaySpinner && (
                                                                <>{!isSend ? t('validationMessage.savingReimbursement') : t('validationMessage.sendingReimbursement')} <Spinner color='success'/><br/></>
                                                            )}
                                                            {grossAmount <= 0 && t("reimbursement.sendInfo")}
                                                        </Col>
                                                        <Col lg={12} className="d-flex gap-2">
                                                            {id !== "" && (
                                                                <Button
                                                                    className="rounded-2 border-0 d-flex align-items-center justify-content-center rpv2-btn-delete"
                                                                    onClick={() => setDisplayDeleteReimbursementModal(true)}>
                                                                    <i className="bx bx-x-circle fs-5 pe-1"/> {t("button.delete")}
                                                                </Button>
                                                            )}
                                                            <CustomSubmitButton 
                                                                customClass="flex-fill"
                                                                text={t('button.saveReimbursement')} 
                                                                id='saveReimbursement' 
                                                                icon='bx bx-save pe-2' 
                                                                doClick={false}
                                                                bgColor='bg-green-soft'
                                                                customClick={async () => {
                                                                    if (CheckRequired()) {
                                                                        $("#forms").addClass("d-none");
                                                                        setIsSend(false);
                                                                        checkIfHaveChanges("save");
                                                                        setDisplaySendModal(true);
                                                                    }
                                                                }}
                                                            />
                                                            <CustomSubmitButton 
                                                                customClass="flex-fill"
                                                                text={t('button.send')} 
                                                                id='submitReimbursement' 
                                                                icon='bx bx-send pe-2'
                                                                customClick={async () => {
                                                                    const hasErrors = await HandleValidateParticipants();
                                                                    if (!hasErrors) {
                                                                        if (CheckRequired()) {
                                                                            $("#forms").addClass("d-none");
                                                                            setIsSend(true);
                                                                            checkIfHaveChanges();
                                                                            await ConfirmFunds();
                                                                        }
                                                                    } else {
                                                                        setAccordionStatusParticipants(true);
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </>
                        </>
                    )}
                </>
            ) : ""}
        </>
    );
}